  /* ---------- landing ---------- */
  function renderLanding() {
    renderHero();
    renderExhStack();
    renderDzIndex();
    wireShotHandoff();
    /* the landing's readings, settled and written to the body because the
       stylesheets select on them: hero.css, plate.css and register.css each name
       the value below */
    document.body.dataset.wash = 'range';
    renderRange();
    document.body.dataset.drift = '1';
    document.body.dataset.heroexit = 'dream';
    /* hxGround asks the same gates the scrubbed exit asks in assets/hero.css, on
       every screen; where the scrub cannot run the desk keeps the static retreat */
    const hxGround = !REDUCE &&
      window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()');
    document.body.dataset.hero = 'hold';
    wireHero(hxGround ? 'dream' : (isDesktop() ? 'hold' : 'static'));
    document.body.dataset.plate = 'over';
    document.body.dataset.fill = 'zoom';
    document.body.dataset.note = 'hover';
    document.body.dataset.mark = 'tumble4';
    renderPlate();
    document.body.dataset.burial = 'curtain';
    document.body.dataset.tail = 'cut';
    /* the register resists a stretch of scroll before the footer, and only where
       a pointer hovers */
    if (isDesktop()) {
      document.body.dataset.register = 'stall';
      const dzEl = document.getElementById('designers');
      if (dzEl) {
        const dzStage = document.createElement('div');
        dzStage.className = 'dz-stage';
        dzEl.parentNode.insertBefore(dzStage, dzEl);
        dzStage.appendChild(dzEl);
      }
    }
  }

  /* ---------- the index head's machinery, shared by products and posts ---------- */
  function buildDrop(id, name, currentLabel, options, apply) {
    const host = document.getElementById(id);
    if (!host) return;
    const optLinks = options.map(function (o) {
      /* no maker-name class: .tb-opts renders every option in caps (list.css) */
      return '<a href="' + o.href + '"' + (o.on ? ' class="on"' : '') + '>' +
        esc(o.label) + '</a>';
    }).join('');
    host.innerHTML =
      '<button type="button" aria-haspopup="true" aria-expanded="false">' +
      '<span class="u u-gray">' + name + '</span>' +
      '<span class="u tb-val">' + esc(currentLabel) + '</span>' +
      '<svg class="tb-caret" viewBox="0 0 8 5" aria-hidden="true"><path d="M1 1 L4 4 L7 1" fill="none" stroke="currentColor"/></svg>' +
      '</button>' +
      /* the roll is the single child the in-page open animation collapses */
      '<span class="tb-opts"><span class="tb-roll">' + optLinks + '</span></span>';
    host.querySelector('.tb-roll').addEventListener('click', function (e) {
      const a = e.target.closest && e.target.closest('a');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
      e.preventDefault();
      history.pushState(null, '', a.getAttribute('href'));
      (apply || function () { turnGrid(renderList); })();
    });

    const btn = host.querySelector('button');
    btn.addEventListener('click', function () {
      const open = !host.classList.contains('open');
      /* deliberate: opening one drop does not shut the other */
      host.classList.toggle('open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
    /* the open class lives on the host, which survives a rebuild; the button does
       not, so the state it announces is put back on the new one */
    btn.setAttribute('aria-expanded', String(host.classList.contains('open')));
  }
  function shutDrops() {
    document.querySelectorAll('.tb-drop.open').forEach(function (d) {
      d.classList.remove('open');
      d.querySelector('button').setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    /* opening may have moved focus into the options; hand it back to the button */
    const openDrop = document.querySelector('.tb-drop.open');
    shutDrops();
    if (openDrop) openDrop.querySelector('button').focus();
  });

  /* ---------- the index turning over under a filter ---------- */
  const GRID_EASE = 'cubic-bezier(0, 0, 0.58, 1)';
  let gridBusy = false;

  function gridCells() {
    return Array.prototype.slice.call(document.querySelectorAll('#wk-grid .wg-cell'));
  }

  function gridDelays() {
    const grid = document.getElementById('wk-grid');
    if (!grid) return [];
    let box = grid.getBoundingClientRect(), max = 1;
    const ds = gridCells().map(function (el) {
      const r = el.getBoundingClientRect();
      const dx = ((r.left + r.width / 2) - box.left) / Math.max(1, box.width);
      const dy = ((r.top + r.height / 2) - box.top) / Math.max(1, box.height);
      const d = Math.sqrt(dx * dx + dy * dy);
      max = Math.max(max, d);
      return d;
    });
    return ds.map(function (d) { return (d / max) * 200; });
  }

  function turnGrid(render) {
    if (REDUCE || !document.body.animate) { render(); settleScroll(); return; }
    if (gridBusy) { render(); settleScroll(); return; }
    gridBusy = true;
    const dOut = gridDelays();
    /* the forwards fill is cancelled after the rebuild: surviving cells are the
       same elements, and a fill left on them pins a card at opacity 0 for good */
    const out = gridCells().map(function (el, i) {
      return el.animate(
        [{ opacity: 1, transform: 'translateY(0)' },
          { opacity: 0, transform: 'translateY(-20px)' }],
        { duration: 200, delay: dOut[i], easing: GRID_EASE, fill: 'forwards' }
      );
    });
    Promise.all(out.map(function (a) { return a.finished; })).catch(function () {}).then(function () {
      render();
      settleScroll();
      out.forEach(function (a) { try { a.cancel(); } catch (e) {} });
      const dIn = gridDelays();
      return Promise.all(gridCells().map(function (el, i) {
        return el.animate(
          [{ opacity: 0, transform: 'translateY(20px)' },
            { opacity: 1, transform: 'none' }],
          { duration: 300, delay: dIn[i], easing: GRID_EASE, fill: 'backwards' }
        ).finished;
      }));
    }).catch(function () {}).then(function () { gridBusy = false; });
  }

  /* filtering shortens the page under a reader who did not navigate: the offset is
     clamped to the section's own foot, and Lenis is told at once because its
     debounced measure would drive against a height that is no longer there */
  function settleScroll() {
    const sec = document.querySelector('[data-section="products-index"]');
    if (!sec) return;
    const docMax = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    const secBottom = sec.offsetTop + sec.offsetHeight;
    const keep = Math.max(0, Math.min(docMax, secBottom - window.innerHeight));
    const live = (typeof lenis !== 'undefined' && lenis) ? lenis : null;
    if (live) live.resize();
    const y = live ? live.targetScroll : window.scrollY;
    if (y <= keep) return;
    if (live) live.scrollTo(keep, { immediate: true });
    else window.scrollTo(0, keep);
  }

  function pickList(name) {
    return String(param(name) || '').split(',').filter(Boolean);
  }

  function pickLabel(list, nameOf) {
    if (!list.length) return 'all';
    if (list.length === 1) return nameOf(list[0]);
    return list.length + ' picked';
  }

  /* every control rebuilds the whole query, so the filters compose */
  function queryHref(base, standing) {
    return function (over) {
      const v = {};
      Object.keys(standing).forEach(function (k) { v[k] = standing[k]; });
      Object.keys(over).forEach(function (k) { v[k] = over[k]; });
      const u = new URLSearchParams();
      Object.keys(v).forEach(function (k) { if (v[k]) u.set(k, v[k]); });
      const q = u.toString();
      return base + (q ? '?' + q : '');
    };
  }

  /* ---------- artworks.html / products.html ----------
     the half comes from the page, never the URL; only view controls ride the query */
  const SORTS = {
    maker: function (a, b) {
      return makerById[a.maker_id].name.localeCompare(makerById[b.maker_id].name) ||
        a.title.localeCompare(b.title);
    }
  };

  /* ---------- the index card and its own photographs ---------- */
  /* both must match snippets/wg-cell.liquid, or the store's cells and cells
     written here ask for different sources and the browser fetches each
     photograph twice; CELL_SIZES is the fallback for a page whose grid carries
     no data-cell-sizes */
  const CELL_WIDTHS = [320, 480, 640, 960, 1280];
  const CELL_SRC_W = 640;
  const CELL_SIZES = '(max-width: 600px) 100vw, 280px';
  function cellSizes() {
    const grid = document.getElementById('wk-grid');
    return (grid && grid.dataset.cellSizes) || CELL_SIZES;
  }
  function sizeSrc(src, w) {
    return /[?&]width=/.test(src) ? src.replace(/([?&]width=)\d+/, '$1' + w)
      : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  function cellSrcset(src) {
    return CELL_WIDTHS.map(function (w) { return sizeSrc(src, w) + ' ' + w + 'w'; }).join(', ');
  }
  /* only the lead is written with a live source; the rest wait for hydrate */
  function wgShotHtml(s, lead) {
    const one = sizeSrc(s.src, CELL_SRC_W), set = cellSrcset(s.src);
    return '<img class="img-contain" ' +
      (lead ? 'src="' + one + '" srcset="' + set + '"' : 'data-src="' + one + '" data-srcset="' + set + '"') +
      ' sizes="' + esc(cellSizes()) + '" alt="' + esc(s.cap) + '" loading="lazy" decoding="async">';
  }

  /* the ring: three identical copies, the reader kept in the middle one, the fold
     back a copy's width unseen */
  const WG_COPIES = 3;
  /* room enough that the sources are in before the card can be looked at */
  const WG_NEAR = '250px 0px';

  function wgCopyHtml(shots, echo) {
    return shots.map(function (s, i) {
      return '<span class="wg-shot"' + (echo ? ' aria-hidden="true"' : '') + '>' +
        wgShotHtml(s, i === 0) + '</span>';
    }).join('');
  }

  function wgMediaHtml(w, shots) {
    if (!shots.length) return '<span class="cell-type"><em>' + esc(w.material.split(',')[0]) + '</em></span>';
    if (shots.length < 2) return wgShotHtml(shots[0], true);
    return '<span class="wg-shots">' +
      wgCopyHtml(shots, true) + wgCopyHtml(shots) + wgCopyHtml(shots, true) +
      '</span>';
  }

  function wgCellHtml(w) {
    const m = makerById[w.maker_id];
    const st = statusOf(w.status);
    const shots = productShots(w);
    /* outside the card's link, since a button may not stand inside one; laid back
       over the photograph by assets/list.css */
    const nav = shots.length > 1
      ? '<span class="wg-nav">' +
        pdcArrow('prev', 'previous photograph') +
        pdcArrow('next', 'next photograph') + '</span>'
      : '';
    /* the reading finds standing cards by data-work; a card written without it can
       never be reconciled and the grid grows on every filter change */
    return '<div class="wg-cell" data-work="' + esc(w.id) + '">' +
      '<a class="wg-link" href="' + itemHref(w) + '">' +
      '<span class="wg-panel">' +
      '<span class="wg-state' + (w.status === 'sold' ? ' is-sold' : '') + '">' + st.label + '</span>' +
      wgMediaHtml(w, shots) + '</span>' +
      '<span class="wg-cap">' +
      '<span class="wg-maker">' + esc(m.name) + '</span>' +
      '<em class="wg-name">' + esc(w.title) + '</em>' +
      '<span class="wg-desc">' + esc(w.material) + '</span>' +
      /* a sold card strikes its price rather than dropping it: an empty slot would
         drop this caption below its neighbours' (wg-cell.liquid writes the same
         two spans) */
      '<span class="wg-price">' + (w.status === 'sold'
        ? '<s class="wg-was">' + fmtKRW(w.price) + '</s><span class="wg-gone">' + esc(said('status', w.status)) + '</span>'
        : fmtKRW(w.price)) + '</span>' +
      '</span></a>' + nav + '</div>';
  }

  /* the view-transition name (base.css opens the door with @view-transition); two
     elements wearing it at once cancel the whole transition, so exactly one may
     hold it and whoever held it last gives it up first */
  const VT_SHOT = 'product-shot';

  let vtHeld = null;
  function handOffShot(img) {
    if (vtHeld && vtHeld !== img) vtHeld.style.viewTransitionName = '';
    vtHeld = img || null;
    if (img) img.style.viewTransitionName = VT_SHOT;
  }

  /* the photograph the card is scrolled to; a single-photograph card has no
     scroller to ask */
  function wgShownImg(cell) {
    const track = cell.querySelector('.wg-shots');
    if (!track) return cell.querySelector('.wg-panel img');
    const cells = Array.prototype.slice.call(track.querySelectorAll('.wg-shot'));
    let at = 0, best = Infinity;
    cells.forEach(function (c, i) {
      const d = Math.abs(c.offsetLeft - track.scrollLeft);
      if (d < best) { best = d; at = i; }
    });
    return cells[at] && cells[at].querySelector('img');
  }

  /* the Navigation API first: on a traversal document.referrer still holds
     whatever led here the first time, and would name the wrong card */
  function arrivedFrom() {
    if (window.navigation && navigation.activation && navigation.activation.from) {
      return navigation.activation.from.url || '';
    }
    return document.referrer || '';
  }

  /* coming back from a product, the card it was opened from takes the name */
  function wgReturnHandoff() {
    const from = arrivedFrom();
    if (from.indexOf('/products/') < 0) return;
    const id = (from.split('/products/')[1] || '').split(/[?#]/)[0];
    if (!id) return;
    Array.prototype.slice.call(document.querySelectorAll('.wg-cell')).forEach(function (cell) {
      const link = cell.querySelector('.wg-link');
      if (!link) return;
      const href = link.getAttribute('href') || '';
      if ((href.split('id=')[1] || '').split('&')[0] === id) handOffShot(wgShownImg(cell));
    });
  }

  /* links wrapping one photograph of a work; the index's grid is not here, its
     cards answer with the one they are scrolled to (wgShownImg) */
  const SHOT_LINKS = '.pw-cell, .dzp-item';

  function wireShotHandoff() {
    Array.prototype.slice.call(document.querySelectorAll(SHOT_LINKS)).forEach(function (a) {
      a.addEventListener('click', function () { handOffShot(a.querySelector('img')); });
    });
  }

  /* px of travel before a press counts as a drag rather than a click */
  const DRAG_SLOP = 10;
  /* ms of stillness before the fold: it is an instant jump, and a smooth scroll or
     a snap keeps writing the offset for a while after the press that started it */
  const WG_SETTLE_MS = 120;

  function wireCardShots() {
    Array.prototype.slice.call(document.querySelectorAll('.wg-cell')).forEach(function (cell) {
      const link = cell.querySelector('.wg-link');
      if (link) link.addEventListener('click', function () { handOffShot(wgShownImg(cell)); });

      const track = cell.querySelector('.wg-shots');
      const nav = cell.querySelector('.wg-nav');
      if (!track || !nav) return;
      const prev = nav.querySelector('.pdc-prev'), next = nav.querySelector('.pdc-next');

      let fed = false;
      function hydrate() {
        if (fed) return;
        fed = true;
        Array.prototype.forEach.call(track.querySelectorAll('img[data-src], img[data-srcset]'), function (img) {
          /* srcset BEFORE src: given src first the browser may commit to the
             fallback width and never read the set, silently */
          const set = img.getAttribute('data-srcset');
          if (set) { img.srcset = set; img.removeAttribute('data-srcset'); }
          const one = img.getAttribute('data-src');
          if (one) { img.src = one; img.removeAttribute('data-src'); }
        });
      }
      if (window.IntersectionObserver) {
        const near = new IntersectionObserver(function (rows) {
          for (let i = 0; i < rows.length; i++) {
            if (rows[i].isIntersecting) { hydrate(); near.disconnect(); return; }
          }
        }, { rootMargin: WG_NEAR });
        near.observe(cell);
      } else hydrate();
      cell.addEventListener('pointerenter', hydrate);
      cell.addEventListener('touchstart', hydrate, { passive: true });

      function copyWidth() { return track.scrollWidth / WG_COPIES; }

      function recentre() {
        const one = copyWidth();
        if (!one) return;
        if (track.scrollLeft < one * 0.5) track.scrollLeft += one;
        else if (track.scrollLeft > one * 1.5) track.scrollLeft -= one;
      }

      let settle = 0;
      function afterSettle() {
        clearTimeout(settle);
        settle = setTimeout(recentre, WG_SETTLE_MS);
      }

      function steered() { cell.dataset.steered = '1'; }

      /* the hover peek moves the scroller, unanimated: a cross-fade paints two
         photographs at once, which multiply against the paper and read as a
         smudge, and an animated move would set the whole row travelling */
      function peek(on) {
        if (cell.dataset.steered || !track.clientWidth) return;
        track.scrollLeft = copyWidth() + (on ? track.clientWidth : 0);
      }
      cell.addEventListener('pointerenter', function () { peek(true); });
      cell.addEventListener('pointerleave', function () { peek(false); });

      function step(dir) {
        hydrate();
        steered();
        track.scrollTo({
          left: track.scrollLeft + dir * track.clientWidth,
          behavior: REDUCE ? 'auto' : 'smooth'
        });
      }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });

      /* touch and trackpad already move a scroller; only a mouse needs the drag */
      let dragged = false;
      track.addEventListener('pointerdown', function (e) {
        steered();
        if (e.button || e.pointerType !== 'mouse') return;
        /* cleared at the press: a pull released off the card lands no click, and
           a standing verdict would eat the next real one */
        dragged = false;
        let startX = e.clientX, from = track.scrollLeft, moved = false;
        /* mandatory snapping and a hand-written offset cannot both own the scroll */
        const snap = track.style.scrollSnapType;
        track.style.scrollSnapType = 'none';
        track.classList.add('dragging');
        function move(ev) {
          if (Math.abs(ev.clientX - startX) > DRAG_SLOP) moved = true;
          track.scrollLeft = from - (ev.clientX - startX);
        }
        function up() {
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', up);
          window.removeEventListener('pointercancel', up);
          track.classList.remove('dragging');
          track.style.scrollSnapType = snap;
          dragged = moved;
        }
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
        window.addEventListener('pointercancel', up);
      });
      /* a press that travelled is a drag, not a click through to the product */
      track.addEventListener('click', function (e) {
        if (!dragged) return;
        dragged = false;
        e.preventDefault();
      }, true);

      /* a trackpad push leaves no press behind, so the peek learns of it here */
      track.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) steered();
      }, { passive: true });

      track.addEventListener('scroll', afterSettle, { passive: true });

      /* homed once, at first width; a later resize only folds, since re-homing
         would yank a steered reader back to the first photograph */
      let homed = false;
      function home() {
        if (!track.clientWidth) return;
        if (homed) { recentre(); return; }
        homed = true;
        clearTimeout(settle);
        track.scrollLeft = copyWidth();
      }
      if (window.ResizeObserver) new ResizeObserver(home).observe(track);
      home();
    });
  }

  if (page === 'list') {
    window.addEventListener('popstate', function () { turnGrid(renderList); });
  }

  /* `list` marks a field a work holds SEVERAL of, answered by membership rather
     than equality; `name` is the theme's word for the row when the store leaves
     the label empty */
  const ROW = {
    maker:       { param: 'maker',    get: function (w) { return w.maker_id; },
                   name: function (H) { return H.maker; } },
    category:    { param: 'cat',      get: function (w) { return w.category; }, path: true },
    materials:   { param: 'material', get: function (w) { return w.materials; }, list: true },
    size_filter: { param: 'size',     get: function (w) { return w.size_filter; }, list: true },
    edition:     { param: 'edition',  get: function (w) { return w.edition; } },
    status:      { param: 'status',   get: function (w) { return w.status; } }
  };
  function holds(w, row, v) {
    const got = ROW[row.field].get(w);
    if (got == null) return false;
    return ROW[row.field].list ? got.indexOf(v) >= 0 : got === v;
  }
  function valuesIn(set, row) {
    const out = [];
    set.forEach(function (w) {
      const got = ROW[row.field].get(w);
      if (got == null) return;
      (ROW[row.field].list ? got : [got]).forEach(function (v) {
        if (v !== '' && out.indexOf(v) < 0) out.push(v);
      });
    });
    return out;
  }
  /* an empty board asks nothing, no default rows: an absent toolbar is visible
     where a wrong one is not */
  function filterRows() {
    return (S.filters || []).filter(function (r) { return ROW[r.field]; });
  }

  function renderList() {
    const side = SIDE;
    const H = HALF[side];
    /* one category rides as a /collections/ path, canonical for the crawlers;
       several at once, or none, ride the query on the index's own path */
    const pathValue = (function () {
      const m = location.pathname.match(/\/collections\/([^\/?]+)/);
      return m && m[1] !== 'products' ? decodeURIComponent(m[1]) : null;
    })();
    const rows = filterRows().map(function (r) {
      let picks = pickList(ROW[r.field].param);
      if (!picks.length && ROW[r.field].path && pathValue) picks = [pathValue];
      return { field: r.field, label: r.label, picks: picks };
    });
    function rowOf(field) {
      for (let i = 0; i < rows.length; i++) if (rows[i].field === field) return rows[i];
      return { field: field, picks: [] };
    }
    const sort = 'maker';
    /* single-valued but still written: the flag scopes the panel's whole block in
       assets/list.css, and stripping it drops every rule under that selector */
    document.body.dataset.sort = 'panel';

    let works = S.works.filter(function (w) { return w.side === side; });

    function has(set, test) {
      for (let i = 0; i < set.length; i++) if (test(set[i])) return true;
      return false;
    }
    /* a pick no work answers any more normalises to all rather than an empty page */
    rows.forEach(function (r) {
      r.picks = r.picks.filter(function (v) {
        return has(works, function (w) { return holds(w, r, v); });
      });
    });
    /* within a row picks widen (either of two designers), between rows they
       narrow (a designer AND a category) */
    function under(skip) {
      return works.filter(function (w) {
        for (let i = 0; i < rows.length; i++) {
          const r = rows[i];
          if (r === skip || !r.picks.length) continue;
          if (!has(r.picks, function (v) { return holds(w, r, v); })) return false;
        }
        return true;
      });
    }
    /* a typed combination no product answers lets rows go, narrowest first, until
       something stands; the panel cannot compose such a set */
    while (!under(null).length && has(rows, function (r) { return r.picks.length; })) {
      for (let k = rows.length - 1; k >= 0; k--) {
        if (rows[k].picks.length) { rows[k].picks = []; break; }
      }
    }
    /* each row offers what stands under the OTHER rows, plus what it already
       holds, or an answer could not be taken back */
    rows.forEach(function (r) {
      const here = valuesIn(under(r), r);
      r.picks.forEach(function (v) { if (here.indexOf(v) < 0) here.push(v); });
      r.options = here;
    });

    /* every option rebuilds the whole address; a flag left out of this set is
       dropped by the first press */
    function listUrl(over) {
      let q = {}, pathList = null;
      rows.forEach(function (r) {
        const pm = ROW[r.field].param;
        const v = pm in over ? over[pm] : r.picks.join(',');
        const list = String(v == null ? '' : v).split(',').filter(Boolean);
        if (ROW[r.field].path && list.length === 1) { pathList = list[0]; return; }
        q[pm] = list.length ? list.join(',') : null;
      });
      const base = pathList
        ? H.list.replace(/\/products$/, '/' + encodeURIComponent(pathList))
        : H.list;
      return queryHref(base, {})(q);
    }
    const href = listUrl;
    function oneOff(r, v) {
      const o = {}; o[ROW[r.field].param] = v; return o;
    }
    function toggled(list, v) {
      const next = list.indexOf(v) < 0 ? list.concat([v])
        : list.filter(function (x) { return x !== v; });
      return next.join(',');
    }

    /* the maker row's label is empty on purpose: the word changes with the half,
       artist in one list and designer in the other */
    function rowName(r) {
      if (r.label) return r.label;
      const own = ROW[r.field].name;
      return own ? own(H) : r.field;
    }
    function valueLabel(r, v) {
      if (r.field === 'maker') return makerById[v] ? makerById[v].name : v;
      return said(r.field, v);
    }
    /* the id, not the class: main-collection.liquid and main-posts.liquid both
       carry .sub-tools */
    const host = document.getElementById('sub-tools');
    if (host) {
      rows.forEach(function (r) {
        const id = 'drop-' + r.field;
        if (!document.getElementById(id)) {
          const d = document.createElement('div');
          d.className = 'tb-drop';
          d.id = id;
          host.appendChild(d);
        }
        buildDrop(id, rowName(r),
          pickLabel(r.picks, function (v) { return valueLabel(r, v); }),
          [{ label: 'all', href: href(oneOff(r, null)), on: !r.picks.length }].concat(
            r.options.map(function (v) {
              return {
                label: valueLabel(r, v),
                href: href(oneOff(r, toggled(r.picks, v))),
                on: r.picks.indexOf(v) >= 0
              };
            })));
      });
    }
    const makerRow = rowOf('maker');
    const sideMakers = makerRow.options || [];

    /* the crumb is a path and a path goes to one place: it names the designer when
       exactly one is picked, and its options jump rather than toggle */
    const lone = makerRow.picks.length === 1 && makerById[makerRow.picks[0]];
    wireCrumb([CRUMB_HOME, crumbSide(side), {
      label: lone ? lone.name : 'all',
      href: href(oneOff(makerRow, null)),
      options: [{ label: 'all', href: href(oneOff(makerRow, null)), on: !makerRow.picks.length }].concat(
        sideMakers.map(function (id) {
          return { label: valueLabel(makerRow, id), href: href(oneOff(makerRow, id)),
                   on: lone && lone.id === id };
        }))
    }]);

    works = under(null);
    works = works.slice().sort(SORTS[sort]);

    document.getElementById('list-label').textContent = H.plural;

    const grid = document.getElementById('wk-grid');
    /* the store wrote every card at first paint (sections/main-collection.liquid);
       the reading reorders and removes rather than rewriting, and builds only a
       card an earlier, narrower reading took away */
    const cells = {};
    Array.prototype.slice.call(grid.querySelectorAll('.wg-cell[data-work]')).forEach(function (c) {
      cells[c.dataset.work] = c;
    });
    works.forEach(function (w) {
      const c = cells[w.id];
      if (c) { grid.appendChild(c); delete cells[w.id]; }
      else grid.insertAdjacentHTML('beforeend', wgCellHtml(w));
    });
    Object.keys(cells).forEach(function (id) { cells[id].remove(); });
    wireCardShots();
    /* after the wiring, so each card stands on the photograph it will hand back */
    wgReturnHandoff();
  }

  /* ---------- posts.html ---------- */
  /* a profile is bucketed by the half of the maker it credits; one whose maker the
     sheet does not name answers to neither and stands under all */
  const POST_KINDS = [
    ['exhibitions', function (p) { return p.type === 'exhibition'; }],
    ['designers', function (p) { return p.type === 'profile' && postSide(p) === 'selective'; }],
    ['artists', function (p) { return p.type === 'profile' && postSide(p) === 'collective'; }]
  ];
  function renderPosts() {
    const style = param('style') === 'rows' ? 'rows' : 'grid';
    /* the three kinds are STRUCTURAL and always stand: an empty half must look
       different from a half that does not exist (a single drafted maker empties
       one silently). Deliberately not the products index's rule, which drops a
       question nothing answers: a category with no works is a shelf never built,
       a post kind is a fixed half whose emptiness is a fact about today. */
    let kind = param('kind');
    if (!POST_KINDS.some(function (k) { return k[0] === kind; })) kind = null;
    document.body.dataset.sort = 'panel';

    const href = queryHref(ROUTES.posts, {
      style: style === 'grid' ? null : style,
      kind: kind
    });

    buildDrop('drop-postkind', 'posts', kind || 'all',
      [{ label: 'all', href: href({ kind: null }), on: !kind }].concat(
        POST_KINDS.map(function (k) {
          return { label: k[0], href: href({ kind: k[0] }), on: k[0] === kind };
        })),
      function () { if (postsTurn) postsTurn(); else renderPosts(); });

    document.querySelectorAll('.view-toggle a').forEach(function (a) {
      a.classList.toggle('active', a.dataset.style === style);
      a.href = href({ style: a.dataset.style });
    });

    wireCrumb([CRUMB_HOME, crumbSide('collective'), { label: 'posts', href: ROUTES.posts }]);

    let standing = null;
    POST_KINDS.forEach(function (k) { if (k[0] === kind) standing = k[1]; });
    const posts = standing ? S.posts.filter(standing) : S.posts.slice();
    const list = document.getElementById('posts-list');
    list.classList.toggle('pl-grid', style === 'grid' && posts.length > 0);

    if (!posts.length) {
      /* "nothing under X yet", a fact about this list and not the record: a
         drafted maker empties a half while an artist exists, so a line claiming
         none exist could be false */
      list.innerHTML = '<p class="pl-empty u u-gray">nothing under ' +
        esc(kind || 'posts') + ' yet</p>';
      return;
    }

    list.innerHTML = posts.map(function (p) {
      /* one unreadable record costs its own row alone; a throw inside the map
         would leave the innerHTML unassigned and empty the whole index */
      try {
        return postRow(p);
      } catch (e) {
        /* said out loud: a silent catch is how a row goes missing and nobody
           learns why */
        if (window.console) window.console.warn('a post could not be read', p && p.id, e);
        return '';
      }
    }).join('');
  }

  /* the box is 322px at its widest, so 960 is the retina-desk pick: 322 at dpr 2
     wants 644 device pixels, 640 falls short, and the browser steps up. A URL
     carrying no width (an asset() path) gets no srcset rather than four copies
     of one address. */
  const PL_WIDTHS = [320, 480, 640, 960];
  const PL_SIZES = '(max-width: 600px) 100vw, 322px';
  function atWidth(src, w) { return src.replace(/([?&]width=)\d+/, '$1' + w); }
  function plSrcset(src, widths) {
    if (!/[?&]width=\d+/.test(src)) return null;
    return (widths || PL_WIDTHS).map(function (w) { return atWidth(src, w) + ' ' + w + 'w'; }).join(', ');
  }
  /* the product stage paints the 5fr column: (100vw − two 40px margins − the
     64px gap) × 5/9; full-bleed under 600, full column to 900. The bare src
     keeps 1600 because the enlarge window reads it for its own copy. */
  const PR_STAGE_WIDTHS = [480, 640, 960, 1280, 1600];
  const PR_STAGE_SIZES = '(max-width: 600px) 100vw, (max-width: 900px) calc(100vw - 80px), calc(55.56vw - 80px)';

  /* the summary the client wrote, or the essay's first sentence when they left it
     blank; 200 is a ceiling for a runaway sentence, not a target */
  function postExcerpt(p) {
    if (p.excerpt) return p.excerpt;
    const text = String(p.essay || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    if (!text) return '';
    const end = text.match(/^.*?[.!?](?=\s|$)/);
    return esc((end ? end[0] : text).slice(0, 200));
  }

  function postRow(p) {
    const src = postHeroSrc(p);
    const set = src && plSrcset(src);
    const media = src
      ? '<img src="' + (set ? atWidth(src, 640) : src) + '"' +
        (set ? ' srcset="' + set + '" sizes="' + PL_SIZES + '"' : '') +
        ' alt="' + esc(p.title) + '" loading="lazy" decoding="async">'
      : '<span class="pl-ph"><span>' + esc(p.title) + '</span></span>';
    return '<a class="pl-row" href="' + postHref(p) + '">' +
      '<span class="pl-img">' + media + '</span>' +
      '<span class="pl-body">' +
      '<span class="u u-gray">' + postKind(p) + '</span>' +
      '<span class="pl-title">' + esc(p.title) + '</span>' +
      '<span class="pl-excerpt">' + postExcerpt(p) + '</span>' +
      '</span>' +
      '<span class="u u-gray pl-end">' +
      esc(p.type === 'exhibition' ? periodRun(p) : makerNames(p.maker_ids)) + '</span>' +
      '</a>';
  }

  /* ---------- the posts index's view toggle, answered in place ---------- */
  let postsTurn = null;
  if (page === 'posts') (function () {
    const EASE_OUT = 'cubic-bezier(0, 0, 0.58, 1)';
    let busy = false;

    function items() {
      return Array.prototype.slice.call(document.querySelectorAll('.pl-row'));
    }

    function delays() {
      const box = document.getElementById('posts-list').getBoundingClientRect();
      let max = 1;
      const ds = items().map(function (el) {
        const r = el.getBoundingClientRect();
        const dx = (box.right - (r.left + r.width / 2)) / Math.max(1, box.width);
        const dy = ((r.top + r.height / 2) - box.top) / Math.max(1, box.height);
        const d = Math.sqrt(dx * dx + dy * dy);
        max = Math.max(max, d);
        return d;
      });
      return ds.map(function (d) { return (d / max) * 200; });
    }

    function wave(done) {
      const dOut = delays();
      const out = items().map(function (el, i) {
        return el.animate(
          [{ opacity: 1, transform: 'translateY(0)' },
           { opacity: 0, transform: 'translateY(-20px)' }],
          { duration: 200, delay: dOut[i], easing: EASE_OUT, fill: 'forwards' }
        ).finished;
      });
      /* whatever becomes of the fade, the URL and the list must agree */
      Promise.all(out).catch(function () {}).then(function () {
        renderPosts();
        const dIn = delays();
        const back = items().map(function (el, i) {
          return el.animate(
            [{ opacity: 0, transform: 'translateY(20px)' },
             { opacity: 1, transform: 'translateY(0)' }],
            { duration: 300, delay: dIn[i], easing: EASE_OUT, fill: 'backwards' }
          ).finished;
        });
        return Promise.all(back);
      }).then(done, done);
    }

    postsTurn = function () {
      if (REDUCE || busy) { renderPosts(); return; }
      busy = true;
      wave(function () { busy = false; });
    };
    document.addEventListener('click', function (e) {
      const a = e.target.closest('.view-toggle a');
      if (!a) return;
      e.preventDefault();
      /* a second click mid-turn is ignored rather than queued */
      if (busy || a.classList.contains('active')) return;
      history.pushState(null, '', a.getAttribute('href'));
      if (REDUCE) { renderPosts(); return; }
      busy = true;
      wave(function () { busy = false; });
    });

    window.addEventListener('popstate', function () { renderPosts(); });
  })();

  /* ---------- post-event.html ---------- */
  /* the store writes the dossier at first paint (sections/main-post.liquid); what
     stands is wired, and the record only adds the tab's name and the path */
  function renderPostEvent() {
    wireDossierIndex(); wirePostCarousel(); wireWorksRun(); wireShotHandoff();
    /* profiles share this renderer now their own page is gone */
    const p = postById[PAGE.ref || param('id')];
    if (!p) return;
    document.title = 'TURIYA · ' + p.title;
    wireCrumb([CRUMB_HOME, crumbSide('collective'), { label: p.title }]);
  }

  /* ---------- artwork.html / product.html ---------- */
  /* the store writes the record at first paint (sections/main-product.liquid);
     what stands is wired, and the record only adds the tab's name and the path */
  function renderItem() {
    /* the name goes on the middle copy, the photograph actually being looked at;
       an echo wearing it hands the transition a picture off the record's side */
    handOffShot(document.querySelector('#pr-images .pr-shot:not([data-echo])'));
    wireCartButton();
    wireWorksRun(); wireShotHandoff();
    const w = workById[PAGE.ref || param('id')];
    if (!w) return;
    const m = makerById[w.maker_id];
    document.title = 'TURIYA · ' + w.title;

    wireCrumb([CRUMB_HOME, crumbSide(w.side), {
      label: m.name,
      href: listHref(w.side, 'maker=' + m.id),
      options: S.makers.filter(function (mk) { return mk.side === w.side; }).map(function (mk) {
        return { label: mk.name, href: listHref(w.side, 'maker=' + mk.id), on: mk.id === m.id };
      })
    }, { label: w.title }]);

    const shots = productShots(w);
    wireProductStage(shots);
    wireProductSheet(shots);
  }

  /* ---------- the stage: one photograph, the height of the screen ----------
     the height is the screen's, not the picture's, so the page has its shape
     before a photograph arrives and the pinned footer (assets/footer.js) is not
     dragged after them. Still built here: the phone rebuilds a post's band in
     this grammar (assets/mobile.js), so the store's stage has a living twin. */
  function productStageHtml(shots) {
    if (!shots.length) return productShotPlaceholder();
    function copy(echo) {
      return shots.map(function (s, i) {
        const set = plSrcset(s.src, PR_STAGE_WIDTHS);
        return '<img class="pr-shot" data-at="' + i + '"' + (echo ? ' data-echo aria-hidden="true"' : '') +
          ' src="' + s.src + '"' +
          (set ? ' srcset="' + set + '" sizes="' + PR_STAGE_SIZES + '"' : '') +
          ' alt="' + (echo ? '' : esc(s.cap)) + '"' +
          (i || echo ? ' loading="lazy"' : '') + ' decoding="async" draggable="false">';
      }).join('');
    }
    const frames = shots.length < 2 ? copy(false)
      : copy(true) + copy(false) + copy(true);
    const nav = shots.length > 1
      ? '<div class="pr-nav">' + pdcArrow('prev', 'previous photograph') +
        pdcArrow('next', 'next photograph') + '</div>'
      : '';
    return '<div class="pr-stage"><div class="pr-frames">' + frames + '</div>' +
      nav + pdcExpand('enlarge the photograph') + productThumbsHtml(shots) + '</div>';
  }

  /* ---------- a scroller with no ends ----------
     WG_COPIES and PW_COPIES predate this and spell the ring out for themselves;
     new rings take it from here rather than becoming a third spelling */
  const RING_COPIES = 3, RING_SETTLE_MS = 120;

  /* the site's one spring, stiffness 300 and damping 30 at unit mass, the same
     one assets/list.css holds as --pdc-spring; a script-driven scroll offset
     cannot take a CSS easing, so it is evaluated straight. Spent by 0.62s,
     which is --pdc-step. */
  const SPRING_W0 = Math.sqrt(300), SPRING_Z = 30 / (2 * Math.sqrt(300));
  const SPRING_WD = SPRING_W0 * Math.sqrt(1 - SPRING_Z * SPRING_Z);
  const SPRING_S = 0.62;
  function springAt(t) {
    return 1 - Math.exp(-SPRING_Z * SPRING_W0 * t) *
      (Math.cos(SPRING_WD * t) + (SPRING_Z * SPRING_W0 / SPRING_WD) * Math.sin(SPRING_WD * t));
  }

  /* `one` is given rather than measured: scrollWidth / 3 is rounded, every fold
     leaves a fraction of a pixel, and they add up until the record parks between
     two photographs */
  function foldRing(track, one, nearest) {
    let settle = 0, running = null;
    function recentre() {
      const w = one();
      if (!w) return;
      if (track.scrollLeft < w * 0.5) track.scrollLeft += w;
      else if (track.scrollLeft > w * 1.5) track.scrollLeft -= w;
    }
    /* a second press mid-travel starts a fresh spring from wherever the record
       got to, so the two never fight over the offset */
    function travel(to, snapAfter) {
      if (REDUCE || !window.requestAnimationFrame) { track.scrollLeft = to; recentre(); return; }
      /* snapping stands down for the travel or the browser re-snaps every frame;
         a caller that already stood it down for a pull says what to put back,
         since restoring it between the two makes the browser snap once early */
      const snap = snapAfter === undefined ? track.style.scrollSnapType : snapAfter;
      /* a fold waiting from the hand that got us here must not land mid-travel */
      clearTimeout(settle);
      track.style.scrollSnapType = 'none';
      running = { from: track.scrollLeft, to: to, at: null };
      const leg = running;
      requestAnimationFrame(function step(now) {
        if (running !== leg) return;
        if (leg.at === null) leg.at = now;
        const t = (now - leg.at) / 1000;
        track.scrollLeft = leg.from + (leg.to - leg.from) * springAt(t);
        if (t < SPRING_S) { requestAnimationFrame(step); return; }
        track.scrollLeft = leg.to;
        running = null;
        recentre();
        track.style.scrollSnapType = snap;
      });
    }
    return {
      one: one,
      travel: travel,
      recentre: recentre,
      afterSettle: function () {
        /* no fold under a running travel; it makes its own at the end */
        if (running) return;
        clearTimeout(settle);
        settle = setTimeout(function () {
          if (running) return;
          recentre();
          /* align to a cell's own offsetLeft: it is the position the snap will
             choose, so the two can never argue */
          if (!nearest) return;
          const to = nearest(track.scrollLeft);
          if (to !== null && Math.abs(to - track.scrollLeft) > 1) travel(to);
        }, RING_SETTLE_MS);
      }
    };
  }

  /* ---------- a sideways push on a desk, read from the stream's shape ----------
     One push steps one photograph. Quiet never comes between flicks (momentum
     runs on after the fingers lift), so the next push is read as a rise out of
     the last one's smoothed fall: crest, drop to CREST_SHARE, then a rise of
     RISE_RATIO over the low. The axis is settled on the first AXIS_TRAVEL px of
     the gesture and held to its end, since a flick's deltaX decays into vertical
     jitter mid-gesture. Any sideways delta is claimed before the axis is known:
     the browser arms its back swipe on the opening events, and an armed swipe
     stops the rest of the gesture from arriving at all. Every host it is given
     shares the one gesture. */
  function swipeStepper(step) {
    const AXIS_TRAVEL = 8, STEP_TRAVEL = 24, HAND_TRAVEL = 40;
    const SMOOTH = 3, CREST_SHARE = 0.6, RISE_RATIO = 1.5, RISE_MIN = 6;
    let wheelSum = 0, wheelSpent = false, wheelIdle = null;
    let wheelAxis = '', wheelWasY = false, wheelTravelX = 0, wheelTravelY = 0;
    let wheelHist = [], wheelCrest = 0, wheelOver = false, wheelLow = 0;

    function endGesture() {
      wheelWasY = wheelAxis === 'y';
      wheelSum = 0; wheelSpent = false; wheelAxis = '';
      wheelTravelX = 0; wheelTravelY = 0;
      wheelCrest = 0; wheelOver = false; wheelLow = 0;
    }

    /* whether this event is the next push rising out of the last one's fall;
       watched for vertical rolls too, which end the same way */
    function nextPush(mag) {
      wheelHist.push(mag);
      if (wheelHist.length > SMOOTH) wheelHist.shift();
      let sm = 0;
      for (let i = 0; i < wheelHist.length; i++) sm += wheelHist[i];
      sm /= wheelHist.length;
      /* a sideways push is watched only once it has had its photograph: before
         that its ramp is still building */
      if (!wheelAxis || (wheelAxis === 'x' && !wheelSpent)) return false;
      if (sm > wheelCrest) wheelCrest = sm;
      if (!wheelOver) {
        if (sm < wheelCrest * CREST_SHARE) { wheelOver = true; wheelLow = sm; }
        return false;
      }
      if (sm < wheelLow) { wheelLow = sm; return false; }
      return sm >= Math.max(wheelLow * RISE_RATIO, wheelLow + RISE_MIN);
    }

    function onWheel(e) {
      const ax = Math.abs(e.deltaX), ay = Math.abs(e.deltaY);
      clearTimeout(wheelIdle);
      wheelIdle = setTimeout(function () { endGesture(); wheelHist = []; }, 220);
      if (nextPush(ax > ay ? ax : ay)) endGesture();
      /* the claim, taken while the axis is open; a roll that has just ended is not
         asked to give its first frames up again */
      if (wheelAxis !== 'y' && ax > 0 && (!wheelWasY || wheelAxis === 'x' || ax > ay)) {
        /* stopPropagation too: Lenis drives the page from the wheel itself and
           never asks whether the event was already spoken for */
        e.preventDefault();
        e.stopPropagation();
      }
      if (!wheelAxis) {
        wheelTravelX += e.deltaX; wheelTravelY += e.deltaY;
        const tx = Math.abs(wheelTravelX), ty = Math.abs(wheelTravelY);
        if (tx < AXIS_TRAVEL && ty < AXIS_TRAVEL) return;
        wheelAxis = tx > ty ? 'x' : 'y';
        wheelWasY = false;
        wheelCrest = 0; wheelOver = false;
        /* this event's own deltaX is added below with every other one */
        wheelSum = wheelTravelX - e.deltaX;
      }
      if (wheelAxis !== 'x') return;
      if (wheelSpent) return;
      wheelSum += e.deltaX;
      if (Math.abs(wheelSum) < STEP_TRAVEL) return;
      const dir = wheelSum > 0 ? 1 : -1;
      wheelSum = 0; wheelSpent = true;
      /* the crest is measured from the step on, not from the ramp that earned it */
      wheelCrest = 0; wheelOver = false;
      step(dir);
    }

    /* the same push by hand, read from the moves rather than the release so a
       short drag never lands as a press; the mouse keeps the wheel, since a pull
       under it would fight the links and the text */
    let handX = 0, handY = 0, lastX = 0, lastY = 0, hand = false;
    function onDown(e) {
      if (e.pointerType === 'mouse' || e.target.closest('a, button')) return;
      hand = true;
      handX = lastX = e.clientX; handY = lastY = e.clientY;
      if (e.currentTarget.setPointerCapture) e.currentTarget.setPointerCapture(e.pointerId);
    }
    function onMove(e) {
      if (!hand) return;
      lastX = e.clientX; lastY = e.clientY;
    }
    function onUp() {
      if (!hand) return;
      hand = false;
      const dx = lastX - handX, dy = lastY - handY;
      if (Math.abs(dx) >= HAND_TRAVEL && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
    }
    function onCancel() { hand = false; }

    return function (host, byHand) {
      if (!host) return;
      host.addEventListener('wheel', onWheel, { passive: false });
      if (!byHand) return;
      host.style.touchAction = 'pan-y';
      host.addEventListener('pointerdown', onDown);
      host.addEventListener('pointermove', onMove);
      host.addEventListener('pointerup', onUp);
      host.addEventListener('pointercancel', onCancel);
    };
  }

  function wireProductStage(shots) {
    const stage = document.querySelector('#pr-images .pr-stage');
    if (!stage || shots.length < 2) return;
    const track = stage.querySelector('.pr-frames');
    let n = shots.length, at = 0;
    const cells = Array.prototype.slice.call(track.children);

    /* every position is a cell's own offsetLeft: an integer clientWidth lands a
       pixel or two beside the fractional grid the snap keeps, and two grids over
       one offset argue forever */
    function cellX(k) {
      const c = cells[Math.min(cells.length - 1, Math.max(0, k))];
      return c ? c.offsetLeft : 0;
    }
    function nearestCell(x) {
      let best = 0, near = Infinity;
      for (let k = 0; k < cells.length; k++) {
        const d = Math.abs(cells[k].offsetLeft - x);
        if (d < near) { near = d; best = k; }
      }
      return best;
    }
    const ring = foldRing(track,
      function () { return cellX(n) - cellX(0); },
      function (x) { return cellX(nearestCell(x)); });

    /* a photograph asked for by name is gone to by its nearest copy */
    function show(i) {
      const want = ((i % n) + n) % n, here = nearestCell(track.scrollLeft);
      let best = want;
      for (let c = 1; c < RING_COPIES; c++) {
        const p = c * n + want;
        if (Math.abs(p - here) < Math.abs(best - here)) best = p;
      }
      ring.travel(cellX(best));
    }
    /* counted from the standing photograph, not the offset a travel is passing
       through: a second push mid-spring would aim from between two photographs */
    function step(dir) { ring.travel(cellX(nearestCell(track.scrollLeft) + dir)); }

    track.addEventListener('scroll', function () {
      const i = nearestCell(track.scrollLeft) % n;
      if (i !== at) { at = i; markThumb(stage, at); }
      ring.afterSettle();
    }, { passive: true });

    stage.querySelector('.pdc-prev').addEventListener('click', function () { step(-1); });
    stage.querySelector('.pdc-next').addEventListener('click', function () { step(1); });
    Array.prototype.slice.call(stage.querySelectorAll('.pr-thumb')).forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
    });

    /* claimed before the scroller sees it: native momentum carries several
       photographs per flick where the band's grammar is one push, one photograph */
    swipeStepper(step)(track);

    /* no mouse pull on purpose: the hand-written version fought the layout, and
       the chevrons, the thumbs and the push steer */

    /* a resize moves every cell, so the offset is put back without travelling */
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        track.scrollLeft = cellX(nearestCell(track.scrollLeft));
      }).observe(track);
    }
    track.scrollLeft = cellX(n);
    markThumb(stage, at);
  }


  function zoomHint() {
    const mac = /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent || '');
    return (mac ? '⌘' : 'ctrl') + ' + scroll to come closer';
  }

  function productThumbsHtml(shots) {
    if (shots.length < 2) return '';
    return '<div class="pr-thumbs">' + shots.map(function (s, i) {
      return '<button type="button" class="pr-thumb' + (i ? '' : ' on') + '" data-at="' + i +
        '" aria-label="' + esc(s.cap) + '"><img src="' + s.src +
        '" alt="" loading="lazy" decoding="async"></button>';
    }).join('') + '</div>';
  }

  function productShotPlaceholder() {
    return '<div class="ph r-4x5"><span>image · forthcoming</span></div>';
  }

  /* marks the standing thumb and keeps it in view of its own scrolling strip */
  function markThumb(root, at) {
    const thumbs = Array.prototype.slice.call(root.querySelectorAll('.pr-thumb'));
    thumbs.forEach(function (t, i) { t.classList.toggle('on', i === at); });
    const strip = root.querySelector('.pr-thumbs');
    if (!strip || !thumbs[at] || strip.scrollWidth <= strip.clientWidth) return;
    const t = thumbs[at];
    strip.scrollTo({
      left: t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2,
      behavior: REDUCE ? 'auto' : 'smooth'
    });
  }

  /* ---------- the sheet: the record laid out to be read, not stepped ---------- */
  function wireProductSheet(shots) {
    if (!shots.length) return;
    const stack = document.getElementById('pr-images');
    if (!stack) return;
    let sheet = null;
    /* the photograph the sheet was opened on: the wave radiates from it going in
       and again coming out */
    let opened = 0;

    const SHEET_OUT_MS = 200, SHEET_IN_MS = 300, SHEET_WAVE = 160;
    const SHEET_EASE = 'cubic-bezier(0, 0, 0.58, 1)';

    function wave(cells, at, out) {
      if (REDUCE || !cells.length || !cells[0].animate) return Promise.resolve();
      const far = Math.max(1, cells.length - 1);
      return Promise.all(cells.map(function (c, i) {
        const delay = (Math.abs(i - at) / far) * SHEET_WAVE;
        return c.animate(out
          ? [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-20px)' }]
          : [{ opacity: 0, transform: 'translateY(20px)' }, { opacity: 1, transform: 'none' }],
        { duration: out ? SHEET_OUT_MS : SHEET_IN_MS, delay: delay, easing: SHEET_EASE,
          /* a leaving sheet may hold its last frame; an arriving one must not, or
             the fill outlives the turn */
          fill: out ? 'forwards' : 'backwards' }).finished;
      })).catch(function () {});
    }

    stack.addEventListener('click', function (e) {
      const img = e.target.closest && e.target.closest('.pr-shot');
      if (img) { open(parseInt(img.dataset.at, 10) || 0); return; }
      /* the standing mark opens on the photograph being read: the nearest offset
         is the one that is up */
      if (e.target.closest && e.target.closest('.pdc-open')) {
        let f = stack.querySelector('.pr-frames'), best = null, near = Infinity;
        Array.prototype.forEach.call(f.querySelectorAll('.pr-shot:not([data-echo])'), function (c) {
          const d = Math.abs(c.offsetLeft - f.scrollLeft);
          if (d < near) { near = d; best = c; }
        });
        open(best ? parseInt(best.dataset.at, 10) || 0 : 0);
      }
    });

    function open(at) {
      if (sheet) return;
      sheet = document.createElement('div');
      sheet.className = 'prsheet';
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-modal', 'true');
      sheet.setAttribute('aria-label', 'photographs, enlarged');
      sheet.innerHTML =
        '<button type="button" class="prsheet-close u" aria-label="close" title="close">' +
        /* not the expand glyph's mirror: at 11px an exact flip reads as a
           staircase, and what carries the meaning is where the corners point */
        '<svg viewBox="0 0 11 11" aria-hidden="true"><path d="M10 4 L7 4 L7 1 M1 7 L4 7 L4 10" fill="none" stroke="currentColor"/></svg></button>' +
        '<p class="prsheet-hint u u-gray">' + zoomHint() + '</p>' +
        /* a stopped Lenis still swallows the wheel's default; data-lenis-prevent
           hands it back */
        '<div class="prsheet-scroll" data-lenis-prevent>' +
        shots.map(function (s) {
          return '<figure class="prsheet-cell"><img src="' + s.src + '" alt="' + esc(s.cap) +
            '" decoding="async" draggable="false"></figure>';
        }).join('') +
        '</div>' +
        /* the map: a picture of where you are, not a control */
        '<div class="prsheet-map" aria-hidden="true"><img alt="" decoding="async" src="' +
        shots[at].src + '"><span class="prsheet-box"></span></div>' +
        productThumbsHtml(shots);

      document.body.appendChild(sheet);
      document.body.dataset.sheet = '1';
      if (typeof lenis !== 'undefined' && lenis) lenis.stop();
      else document.documentElement.style.overflow = 'hidden';

      const scroll = sheet.querySelector('.prsheet-scroll');
      const cells = Array.prototype.slice.call(sheet.querySelectorAll('.prsheet-cell'));
      /* the phone reads the sheet sideways (assets/mobile.css): same machinery,
         axis turned */
      const HORIZ = isPhone();
      const mapEl = sheet.querySelector('.prsheet-map');
      const mapImg = mapEl.querySelector('img');
      const mapBox = sheet.querySelector('.prsheet-box');

      if (at > 0) {
        if (HORIZ) scroll.scrollLeft = cells[at].offsetLeft;
        else scroll.scrollTop = cells[at].offsetTop;
      }
      markThumb(sheet, at);

      /* ---------- closer, without giving up the record ----------
         the zoom lays the cells at a share of the screen's width (--pz) rather
         than transforming one, so the scroller the reader is already in grows
         with them and the reading stays a column */
      const MAX_Z = 4, MAP_H = 86;
      let pz = 1;

      function atPoint(cx, cy) {
        const r = scroll.getBoundingClientRect();
        return { vx: cx - r.left, vy: cy - r.top };
      }

      function zoomTo(nz, cx, cy) {
        if (HORIZ) return zoomCellTo(nz, cx, cy);
        nz = Math.min(MAX_Z, Math.max(1, nz));
        if (Math.abs(nz - pz) < 0.0005) return;
        const p = atPoint(cx, cy);
        const k = nz / pz;
        const contentX = (scroll.scrollLeft + p.vx) * k;
        const contentY = (scroll.scrollTop + p.vy) * k;
        /* sideways the browser may clamp the offset while the row re-lays, landing
           the reader on the FIRST photograph; the point under the fingers is kept
           as a fraction inside its own cell and the offset rebuilt from that
           cell's fresh geometry after the re-lay */
        let anchor = -1, ax = 0, ay = 0;
        if (HORIZ) {
          anchor = zoomCell >= 0 ? zoomCell : (pinchCell >= 0 ? pinchCell : electCell(cx, cy));
          const from = cells[anchor];
          ax = (scroll.scrollLeft + p.vx - from.offsetLeft) / Math.max(1, from.offsetWidth);
          ay = (scroll.scrollTop + p.vy) / Math.max(1, from.offsetHeight);
        }
        pz = nz;
        sheet.style.setProperty('--pz', pz);
        if (pz > 1.001) {
          sheet.dataset.zoomed = '1';
          if (zoomCell < 0) zoomCell = anchor >= 0 ? anchor : (pinchCell >= 0 ? pinchCell : readCell());
        } else {
          delete sheet.dataset.zoomed;
          zoomCell = -1;
        }
        /* force the re-lay before writing the offset, or the browser clamps it to
           the old width */
        void scroll.scrollWidth;
        if (anchor >= 0) {
          const to = cells[anchor];
          scroll.scrollLeft = to.offsetLeft + ax * to.offsetWidth - p.vx;
          scroll.scrollTop = ay * to.offsetHeight - p.vy;
        } else {
          scroll.scrollLeft = contentX - p.vx;
          scroll.scrollTop = contentY - p.vy;
        }
        clampToCell();
        drawMap();
      }

      function readCell() {
        if (HORIZ) {
          /* under the screen's centre, not a third in: a third elected the
             neighbour while a swipe was still settling */
          let x = scroll.scrollLeft + scroll.clientWidth / 2, j = 0;
          cells.forEach(function (c, k) { if (c.offsetLeft <= x) j = k; });
          return j;
        }
        let y = scroll.scrollTop + scroll.clientHeight / 3, i = 0;
        cells.forEach(function (c, k) { if (c.offsetTop <= y) i = k; });
        return i;
      }

      /* elected once from the fingers' midpoint and held for the gesture: a snap
         still settling would re-elect the neighbour, and snapping goes down or
         the widening cells re-snap mid-pinch */
      let pinchCell = -1;
      /* the photograph the reader went in on, held while they stay in close */
      let zoomCell = -1;

      /* sideways the zoom is a transform on the elected cell alone: WebKit
         re-lays the widened row between the write and the paint, so offsets land
         on moved geometry and the picture crawls toward the row's start. The
         desk keeps the widening path, whose scroller pan never raced. */
      let tz = 1, tx = 0, ty = 0, panFrom = null;

      function cellMetrics() {
        const cell = cells[zoomCell < 0 ? 0 : zoomCell];
        const sr = scroll.getBoundingClientRect();
        return {
          cell: cell, w: cell.clientWidth, h: cell.clientHeight,
          /* the cell's UNTRANSFORMED corner: its rect would already carry the
             scale about to change */
          ox: sr.left + cell.offsetLeft - scroll.scrollLeft,
          oy: sr.top - scroll.scrollTop
        };
      }
      /* the photograph's own edges never come inside the screen */
      function clampCell(m) {
        tx = Math.min(0, Math.max(m.w - m.w * tz, tx));
        ty = Math.min(0, Math.max(m.h - m.h * tz, ty));
      }
      function applyCell(m) {
        const st = m.cell.style;
        if (tz > 1.001) {
          st.transformOrigin = '0 0';
          st.transform = 'translate(' + tx.toFixed(2) + 'px, ' + ty.toFixed(2) + 'px) scale(' + tz.toFixed(4) + ')';
        } else {
          st.transform = '';
          st.transformOrigin = '';
        }
      }
      function resetZoom() {
        if (zoomCell >= 0) {
          const st = cells[zoomCell].style;
          st.transform = ''; st.transformOrigin = ''; st.willChange = '';
        }
        tz = 1; tx = 0; ty = 0; zoomCell = -1;
        delete sheet.dataset.zoomed;
        scroll.style.overflow = '';
        scroll.style.scrollSnapType = '';
        drawMap();
      }
      function zoomCellTo(nz, cx, cy) {
        nz = Math.min(MAX_Z, Math.max(1, nz));
        if (Math.abs(nz - tz) < 0.0005) return;
        if (zoomCell < 0) zoomCell = pinchCell >= 0 ? pinchCell : electCell(cx, cy);
        const m = cellMetrics();
        const mx = cx - m.ox, my = cy - m.oy;
        /* the point under the fingers, in the cell's own unscaled coordinates */
        const px = (mx - tx) / tz, py = (my - ty) / tz;
        tz = nz;
        tx = mx - px * tz;
        ty = my - py * tz;
        clampCell(m);
        applyCell(m);
        if (tz > 1.001) {
          sheet.dataset.zoomed = '1';
          m.cell.style.willChange = 'transform';
          /* the scroller stands still in close: the pan is the photograph's own */
          scroll.style.overflow = 'hidden';
          drawMap();
        } else {
          resetZoom();
        }
      }
      function panBy(dxFrom, dyFrom, from) {
        const m = cellMetrics();
        tx = from.tx + dxFrom;
        ty = from.ty + dyFrom;
        clampCell(m);
        applyCell(m);
        drawMap();
      }

      function clampToCell() {
        if (!HORIZ || pz <= 1.001 || zoomCell < 0) return;
        const cell = cells[zoomCell];
        const min = cell.offsetLeft;
        const max = Math.max(min, min + cell.offsetWidth - scroll.clientWidth);
        const x = Math.min(Math.max(scroll.scrollLeft, min), max);
        if (Math.abs(x - scroll.scrollLeft) > 0.5) scroll.scrollLeft = x;
      }

      /* sideways the map pictures the PHOTOGRAPH, not the cell: the photograph is
         cropped into the cell (cover) or set inside it (contain), so the window
         is drawn in the picture's own fractions */
      function drawnRect(cell, img) {
        const cw = cell.clientWidth, ch = cell.clientHeight;
        const iw = img.naturalWidth, ih = img.naturalHeight;
        if (!iw || !ih || !cw || !ch) return null;
        const wide = cell.classList.contains('wide');
        const k = wide ? Math.min(cw / iw, ch / ih) : Math.max(cw / iw, ch / ih);
        const w = iw * k, h = ih * k;
        return { x: (cw - w) / 2, y: (ch - h) / 2, w: w, h: h, iw: iw, ih: ih };
      }

      function drawMap() {
        /* sideways drawn at rest too, so a released sheet never keeps the window
           of the zoom it has just left; the CSS hides it until the reader goes in */
        if (!HORIZ && pz <= 1.001) return;
        const i = zoomCell >= 0 ? zoomCell : (pinchCell >= 0 ? pinchCell : readCell());
        const cell = cells[i], img = cell.querySelector('img');
        const cw = cell.offsetWidth, ch = cell.offsetHeight;
        if (!cw || !ch) return;
        const src = img.currentSrc || img.src;
        if (mapImg.src !== src) mapImg.src = src;
        mapEl.style.height = MAP_H + 'px';
        let fx, fy, fw, fh;
        if (HORIZ) {
          const d = drawnRect(cell, img);
          if (!d) return;
          mapEl.style.width = Math.round(MAP_H * (d.iw / d.ih)) + 'px';
          /* the screen in the cell's own unscaled coordinates, from the transform */
          const vx = -tx / tz - d.x, vy = -ty / tz - d.y;
          fx = vx / d.w;
          fy = vy / d.h;
          fw = (cell.clientWidth / tz) / d.w;
          fh = (cell.clientHeight / tz) / d.h;
        } else {
          mapEl.style.width = Math.round(MAP_H * (cw / ch)) + 'px';
          fx = scroll.scrollLeft / cw;
          fy = (scroll.scrollTop - cell.offsetTop) / ch;
          fw = Math.min(1, scroll.clientWidth / cw);
          fh = Math.min(1, scroll.clientHeight / ch);
        }
        /* the window is part of the photograph, never more than all of it */
        fw = Math.min(1, fw);
        fh = Math.min(1, fh);
        fx = Math.min(1 - fw, Math.max(0, fx));
        fy = Math.min(1 - fh, Math.max(0, fy));
        mapBox.style.left = (fx * 100) + '%';
        mapBox.style.top = (fy * 100) + '%';
        mapBox.style.width = (fw * 100) + '%';
        mapBox.style.height = (fh * 100) + '%';
      }

      scroll.addEventListener('scroll', function () {
        clampToCell();
        markThumb(sheet, readCell());
        drawMap();
      }, { passive: true });

      scroll.addEventListener('wheel', function (e) {
        /* preventDefault stops the browser's own page zoom; stopPropagation stops
           Lenis, which drives the page from the wheel itself */
        if (!e.ctrlKey && !e.metaKey) return;
        e.preventDefault();
        e.stopPropagation();
        /* opposite signs on purpose: a pinch reports fingers-apart as a negative
           delta whatever the scroll setting, while a held key carries only a
           scroll direction that natural scrolling has already inverted */
        const step = e.ctrlKey ? -e.deltaY * 0.012 : e.deltaY * 0.004;
        zoomTo(pz * Math.exp(step), e.clientX, e.clientY);
      }, { passive: false });

      let pinchD = 0;
      /* the browser's own hit test cannot disagree with what the reader sees,
         where offsets can; the arithmetic is the fallback for a midpoint that
         lands on no cell */
      function electCell(clientX, clientY) {
        const el = document.elementFromPoint(Math.round(clientX), Math.round(clientY));
        const cell = el && el.closest ? el.closest('.prsheet-cell') : null;
        const i = cell ? cells.indexOf(cell) : -1;
        return i >= 0 ? i : cellAtX(clientX);
      }
      /* changing scroll-snap-type may itself re-run snapping and hand the scroller
         back at the row's start; the offset is read first and written back */
      function snapOff() {
        if (scroll.style.scrollSnapType === 'none') return;
        const keepX = scroll.scrollLeft, keepY = scroll.scrollTop;
        scroll.style.scrollSnapType = 'none';
        void scroll.scrollWidth;
        if (Math.abs(scroll.scrollLeft - keepX) > 0.5) scroll.scrollLeft = keepX;
        if (Math.abs(scroll.scrollTop - keepY) > 0.5) scroll.scrollTop = keepY;
      }
      /* WebKit reports a two-finger gesture as gesturestart/gesturechange with a
         whole scale, and the synthesised touch pair arrives late or against a
         magnified viewport: where these events exist they are the pinch
         (touch-action in assets/list.css keeps the browser's own zoom off) */
      let hasGesture = 'ongesturestart' in window, gz = 1;
      function cellAtX(clientX) {
        if (!HORIZ) return readCell();
        let x = scroll.scrollLeft + (clientX - scroll.getBoundingClientRect().left), j = 0;
        cells.forEach(function (c, k) { if (c.offsetLeft <= x) j = k; });
        return j;
      }
      /* in close the finger moves the cell's own transform; the scroller is held
         still (zoomCellTo) */
      scroll.addEventListener('touchstart', function (e) {
        if (HORIZ && tz > 1.001 && e.touches.length === 1) {
          panFrom = { x: e.touches[0].clientX, y: e.touches[0].clientY, tx: tx, ty: ty };
        } else {
          panFrom = null;
        }
        if (hasGesture) return;
        if (e.touches.length === 2) {
          pinchD = Math.hypot(e.touches[0].clientX - e.touches[1].clientX,
                              e.touches[0].clientY - e.touches[1].clientY);
          /* elected before snapping goes down */
          pinchCell = electCell((e.touches[0].clientX + e.touches[1].clientX) / 2,
                                (e.touches[0].clientY + e.touches[1].clientY) / 2);
          snapOff();
        }
      }, { passive: true });
      scroll.addEventListener('touchmove', function (e) {
        if (panFrom && e.touches.length === 1) {
          e.preventDefault();
          const dx = e.touches[0].clientX - panFrom.x, dy = e.touches[0].clientY - panFrom.y;
          if (Math.abs(dx) + Math.abs(dy) > DRAG_SLOP) panned = true;
          panBy(dx, dy, panFrom);
          return;
        }
        if (hasGesture || e.touches.length !== 2) return;
        e.preventDefault();
        const d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX,
                           e.touches[0].clientY - e.touches[1].clientY);
        const cx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        const cy = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        if (pinchD) zoomTo((HORIZ ? tz : pz) * d / pinchD, cx, cy);
        pinchD = d;
      }, { passive: false });
      scroll.addEventListener('touchend', function (e) {
        if (e.touches.length < 1) panFrom = null;
        if (hasGesture || e.touches.length >= 2) return;
        release();
      }, { passive: true });

      /* the snap comes back only once the reader is out at full frame again */
      function release() {
        pinchD = 0;
        pinchCell = -1;
        if (HORIZ) {
          /* still in close, the layer hint goes so the engine re-rasterises the
             photograph at the size it now stands at */
          if (tz <= 1.001) resetZoom();
          else if (zoomCell >= 0) cells[zoomCell].style.willChange = '';
          return;
        }
        if (pz <= 1.001) scroll.style.scrollSnapType = '';
      }

      if (hasGesture) {
        scroll.addEventListener('gesturestart', function (e) {
          e.preventDefault();
          gz = HORIZ ? tz : pz;
          pinchCell = electCell(e.clientX, e.clientY);
          snapOff();
        });
        scroll.addEventListener('gesturechange', function (e) {
          e.preventDefault();
          zoomTo(gz * e.scale, e.clientX, e.clientY);
        });
        scroll.addEventListener('gestureend', function (e) {
          e.preventDefault();
          release();
        });
      }

      Array.prototype.slice.call(sheet.querySelectorAll('.pr-thumb')).forEach(function (t, i) {
        t.addEventListener('click', function () {
          /* sideways the zoom lives on one cell's transform, given up before the
             row is steered */
          if (HORIZ && tz > 1.001) resetZoom();
          else if (zoomCell >= 0) zoomCell = i;
          if (HORIZ) scroll.scrollTo({ left: cells[i].offsetLeft, behavior: REDUCE ? 'auto' : 'smooth' });
          else scroll.scrollTo({ top: cells[i].offsetTop, behavior: REDUCE ? 'auto' : 'smooth' });
        });
      });

      sheet.querySelector('.prsheet-close').addEventListener('click', close);
      /* a click leaves, never zooms: a press that sometimes did either made the
         reader aim before every click */
      let panned = false;
      scroll.addEventListener('click', function (e) {
        /* a press that travelled was moving the photograph, not asking to leave */
        if (panned) { panned = false; e.stopPropagation(); return; }
        close();
      });

      /* the mouse gets the one-to-one pull, and the press that ends it is
         swallowed so the sheet does not take it as a way out */
      scroll.addEventListener('pointerdown', function (e) {
        if (e.button || e.pointerType !== 'mouse') return;
        if (HORIZ) return;
        /* only in close: at full width the column always scrolls, and every press
           that shifted a hair would be swallowed instead of giving the sheet up */
        if (!sheet || !sheet.dataset.zoomed) return;
        panned = false;
        const sx = e.clientX, sy = e.clientY;
        let fromL = scroll.scrollLeft, fromT = scroll.scrollTop, moved = false;
        scroll.classList.add('panning');
        function move(ev) {
          if (!moved && Math.abs(ev.clientX - sx) + Math.abs(ev.clientY - sy) > DRAG_SLOP) moved = true;
          scroll.scrollLeft = fromL - (ev.clientX - sx);
          scroll.scrollTop = fromT - (ev.clientY - sy);
        }
        function up() {
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', up);
          window.removeEventListener('pointercancel', up);
          scroll.classList.remove('panning');
          panned = moved;
        }
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
        window.addEventListener('pointercancel', up);
      });

      document.addEventListener('keydown', onKey, true);

      opened = at;
      if (REDUCE || !sheet.animate) return;
      sheet.animate([{ opacity: 0 }, { opacity: 1 }],
        { duration: SHEET_OUT_MS, easing: SHEET_EASE });
      wave(cells, at, false);
    }

    function onKey(e) { if (e.key === 'Escape') close(); }

    function close() {
      if (!sheet) return;
      const el = sheet;
      sheet = null;
      delete document.body.dataset.sheet;
      document.removeEventListener('keydown', onKey, true);
      if (typeof lenis !== 'undefined' && lenis) lenis.start();
      else document.documentElement.style.overflow = '';

      /* a second sheet may open while this one is leaving: the one standing owns
         the scroll, and a sheet on its way out only takes itself */
      let went = false;
      function gone() {
        if (went) return;
        went = true;
        el.remove();
      }
      /* a leaving sheet still covers the screen while it fades; presses meant for
         the page must pass through it */
      el.style.pointerEvents = 'none';
      if (REDUCE || !el.animate) { gone(); return; }
      /* the photographs leave while the ground is already giving way; waiting for
         them made the close read as a held blank */
      wave(Array.prototype.slice.call(el.querySelectorAll('.prsheet-cell')), opened, true);
      el.animate([{ opacity: 1 }, { opacity: 0 }],
        { duration: SHEET_OUT_MS + SHEET_WAVE, easing: SHEET_EASE, fill: 'forwards' })
        .finished.then(gone, gone);
    }
  }

  /* only the work's own photographs, never padded from the maker's other pieces:
     a buyer reads this gallery as the record of the object they are paying for */
  function productShots(w) {
    const srcs = (w.images && w.images.length) ? w.images : (w.image ? [w.image] : []);
    return srcs.map(function (src, i) {
      return { src: src, cap: i ? w.title + ' · detail ' + pad2(i) : w.title };
    });
  }

  /* the cart's sheet is the store's own (sections/main-cart.liquid); the page
     renderer only stands the crumb over it */
  function renderCart() {
    wireCrumb([CRUMB_HOME, { label: 'cart', href: ROUTES.cart || '/cart' }]);
  }

  function cartLinkHTML(label) {
    return '<a class="cart-button" href="' + esc(ROUTES.cart || '/cart') + '">' + label + '</a>';
  }
  function cartSettledHTML() {
    /* the &nbsp; is the gap as TEXT (a plain space at an inline box's end is
       trimmed), and the two marks are written ADJACENT: any markup whitespace
       here would space the line twice */
    return '<span class="cart-button" data-cart-state="report">in the cart,&nbsp;</span>' +
      cartLinkHTML('view&nbsp;\u2192');
  }
  /* stands only while the cart holds work, raised in place so no reload names it */
  function standCartCorner(count) {
    let word = document.getElementById('cart-corner');
    if (!count) {
      if (word) word.remove();
      delete document.body.dataset.cart;
      seatCartCorner();
      return;
    }
    if (!word) {
      word = document.createElement('a');
      word.className = 'corner tr cart-corner u u-gray';
      word.id = 'cart-corner';
      word.href = ROUTES.cart || '/cart';
      const menuBtn = document.getElementById('menu-btn');
      (menuBtn ? menuBtn.parentNode : document.body).insertBefore(word, menuBtn);
    }
    word.textContent = 'Cart ' + count;
    document.body.dataset.cart = count;
    seatCartCorner();
  }

  /* measured, not guessed: a two-digit count or a longer word moves the seat
     rather than colliding (base.css and mobile.css reserve the widths) */
  function seatCartCorner() {
    const root = document.documentElement.style;
    const menuBtn = document.getElementById('menu-btn');
    const word = document.getElementById('cart-corner');
    if (menuBtn) root.setProperty('--menu-room', Math.round(menuBtn.getBoundingClientRect().width) + 16 + 'px');
    if (word) root.setProperty('--cart-room', Math.round(word.getBoundingClientRect().width) + 16 + 'px');
    else root.removeProperty('--cart-room');
  }

  function wireCartButton() {
    const btn = document.querySelector('.buy-block .cart-button[data-variant]');
    if (!btn || !btn.dataset.variant || !window.fetch) return;
    const block = btn.parentNode;
    function settle(html) { block.innerHTML = html; }
    function inCart(done) {
      fetch(ROUTES.root + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          done((cart.items || []).some(function (it) { return String(it.variant_id) === btn.dataset.variant; }));
        })
        .catch(function () { done(false); });
    }
    inCart(function (yes) { if (yes) settle(cartSettledHTML()); });
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.dataset.cartState = 'report';
      btn.textContent = 'adding...';
      fetch(ROUTES.cart_add || '/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }] })
      }).then(function (r) {
        if (r.ok) {
          settle(cartSettledHTML());
          r.json().then(function (res) {
            fetch(ROUTES.root + 'cart.js', { credentials: 'same-origin' })
              .then(function (cr) { return cr.json(); })
              .then(function (cart) { standCartCorner(cart.item_count); })
              .catch(function () {});
          }).catch(function () {});
          return;
        }
        if (r.status === 422) {
          inCart(function (yes) {
            if (yes) settle(cartSettledHTML());
            /* the literal 'sold', not this work's status: the cart refused the
               line whatever the record still claims */
            else settle('<p class="state-word">' + esc(said('status', 'sold')) + '</p>');
          });
          return;
        }
        restore();
      }).catch(restore);
      function restore() {
        btn.disabled = false;
        delete btn.dataset.cartState;
        btn.innerHTML = 'add to cart&nbsp;\u2192';
      }
    });
  }

  /* ---------- the post sheet as a dossier ---------- */

  function pad2(n) { return String(n).padStart(2, '0'); }

  /* the record's own photograph leads; a post without one borrows the first
     work that carries an image */
  function postHeroSrc(p) {
    if (p.hero_image) return p.hero_image;
    const w = firstImageWork(p.work_ids);
    return (w && w.image) || null;
  }

  /* the ring again: three copies, the reader in the middle one, the aria-hidden
     echoes on either side */
  const PW_COPIES = 3;

  /* the mark stands rather than waking on hover: the zoom-in cursor speaks only
     to a desktop hand already resting on the photograph */
  function pdcExpand(label) {
    return '<button type="button" class="pdc-open" aria-label="' + label + '">' +
      '<svg viewBox="0 0 11 11" aria-hidden="true"><path d="M7 1 L10 1 L10 4 M4 10 L1 10 L1 7" ' +
      'fill="none" stroke="currentColor"/></svg></button>';
  }

  function pdcChev(dir) {
    return '<svg viewBox="0 0 6 10" aria-hidden="true"><path d="' +
      (dir === 'prev' ? 'M5 1 L1 5 L5 9' : 'M1 1 L5 5 L1 9') +
      '" fill="none" stroke="currentColor"/></svg>';
  }

  function pdcArrow(dir, label) {
    return '<button type="button" class="pdc-arrow pdc-' + dir + '" aria-label="' + label + '">' +
      pdcChev(dir) + '</button>';
  }

  /* the same bar on the page and in the window */
  function pdcBarHtml(cap, count) {
    return '<div class="pdc-bar">' +
      '<span class="pdc-cap u u-gray" aria-live="polite">' + esc(cap) + '</span>' +
      '<span class="pdc-nav">' + pdcArrow('prev', 'previous photograph') +
      '<span class="pdc-count u u-gray">' + count + '</span>' +
      pdcArrow('next', 'next photograph') +
      /* parted from the steer: a fourth mark inside it read as a third arrow */
      pdcExpand('enlarge the photograph') + '</span>' +
      '</div>';
  }

  /* the window's copies are never lazy: a lazy photograph two steps away fetches
     and decodes inside the travel, which is what a stutter is made of */
  function pdcTrackHtml(slides, at) {
    return '<div class="pdc-track">' +
      slides.map(function (s, i) {
        return '<figure class="pdc-cell' + (i === at ? ' on' : '') + '">' +
          '<img class="pdc-shot" src="' + s.src + '"' +
          ' alt="' + esc(s.cap) + '" data-cap="' + esc(s.cap) + '" decoding="async"></figure>';
      }).join('') +
      '</div>';
  }

/* wiring: ports as-is */

  /* the same band election, click lock and travelling dot as assets/core.js
     wireRailIndex */
  function wireDossierIndex() {
    [].forEach.call(document.querySelectorAll('.pdx-idx'), wireOneDossierIndex);
  }
  function wireOneDossierIndex(idx) {
    const secs = Array.prototype.slice.call(idx.querySelectorAll('a')).map(function (l) {
      return document.getElementById(l.getAttribute('href').slice(1));
    }).filter(Boolean);
    wireRailIndex({ idx: idx, secs: secs, dot: true });
  }

  /* ---------- the selected works, when the record outruns the row ---------- */
  function wireWorksRun() {
    [].forEach.call(document.querySelectorAll('.pw[data-runs]'), wireOneWorksRun);
  }
  function wireOneWorksRun(pw) {
    const run = pw.querySelector('.pdc-nav');
    if (!run) return;
    const track = pw.querySelector('.pw-track');
    /* a run with a nav and no track used to throw here; one broken run must not
       take the runs after it down */
    if (!track) return;
    const prev = run.querySelector('.pdc-prev'), next = run.querySelector('.pdc-next');
    const count = run.querySelector('.pdc-count');
    const total = track.children.length / PW_COPIES;

    /* the same spring as the stage, 300 against 30, evaluated straight: a
       script-driven scroll offset cannot take a CSS easing */
    const SPRING_W0 = Math.sqrt(300), SPRING_Z = 30 / (2 * Math.sqrt(300));
    const SPRING_WD = SPRING_W0 * Math.sqrt(1 - SPRING_Z * SPRING_Z);
    function settleAt(t) {
      return 1 - Math.exp(-SPRING_Z * SPRING_W0 * t) *
        (Math.cos(SPRING_WD * t) + (SPRING_Z * SPRING_W0 / SPRING_WD) * Math.sin(SPRING_WD * t));
    }

    function copyWidth() { return track.scrollWidth / PW_COPIES; }

    function recentre() {
      const one = copyWidth();
      if (!one) return;
      if (track.scrollLeft < one * 0.5) track.scrollLeft += one;
      else if (track.scrollLeft > one * 1.5) track.scrollLeft -= one;
    }

    /* one work at a time, not one screenful, or the count moves by three and the
       reader cannot tell what the arrow did */
    function stride() {
      const cell = track.children[0];
      if (!cell) return track.clientWidth;
      return cell.getBoundingClientRect().width +
        parseFloat(getComputedStyle(track).columnGap || 0);
    }

    let running = null;
    function page(dir) {
      const from = track.scrollLeft;
      const to = from + dir * stride();
      if (REDUCE || !window.requestAnimationFrame) { track.scrollLeft = to; recentre(); return; }
      /* snapping stands down for the travel or the browser re-snaps every frame */
      const snap = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      /* a second press mid-travel starts a fresh spring from wherever the row got to */
      running = { from: from, to: to, at: null };
      const leg = running;
      requestAnimationFrame(function step(now) {
        if (running !== leg) return;
        if (leg.at === null) leg.at = now;
        const t = (now - leg.at) / 1000;
        track.scrollLeft = leg.from + (leg.to - leg.from) * settleAt(t);
        if (t < 0.62) { requestAnimationFrame(step); return; }
        track.scrollLeft = leg.to;
        running = null;
        recentre();
        track.style.scrollSnapType = snap;
      });
    }
    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });

    let dragged = false;
    track.addEventListener('pointerdown', function (e) {
      /* only a mouse: touch and trackpad already move a scroller */
      if (e.button || e.pointerType !== 'mouse') return;
      /* cleared at the press: a pull released off a work lands no click, and a
         standing verdict swallows later real ones (wireCardShots, same trap) */
      dragged = false;
      let startX = e.clientX, from = track.scrollLeft, moved = false;
      const snap = track.style.scrollSnapType;
      running = null;
      track.style.scrollSnapType = 'none';
      track.classList.add('dragging');
      function move(ev) {
        if (Math.abs(ev.clientX - startX) > DRAG_SLOP) moved = true;
        track.scrollLeft = from - (ev.clientX - startX);
        recentre();
      }
      function up() {
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', up);
        window.removeEventListener('pointercancel', up);
        track.classList.remove('dragging');
        track.style.scrollSnapType = snap;
        dragged = moved;
        recentre();
      }
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', up);
      window.addEventListener('pointercancel', up);
    });
    track.addEventListener('click', function (e) {
      if (!dragged) return;
      dragged = false;
      e.preventDefault();
    }, true);

    /* the count names the first showing work, counted off the works themselves:
       widths vary, and on a turning row a share of the scroll means nothing */
    function mark() {
      if (!track.children[0]) return;
      const first = Math.round((track.scrollLeft - copyWidth()) / Math.max(1, stride()));
      const at = ((first % total) + total) % total;
      count.textContent = pad2(at + 1) + ' / ' + pad2(total);
    }
    track.addEventListener('scroll', mark, { passive: true });
    if (window.ResizeObserver) {
      new ResizeObserver(function () { track.scrollLeft = copyWidth(); mark(); }).observe(track);
    }
    track.scrollLeft = copyWidth();
    mark();
  }

  /* ---------- the dossier band and its lifted stage ----------
     the travel rides the spring sampled into linear() in assets/list.css */
  function wirePostCarousel() {
    [].forEach.call(document.querySelectorAll('.pdc'), wireOnePostCarousel);
  }
  function wireOnePostCarousel(root) {
    const frame = root.querySelector('.pdc-band');
    const slides = Array.prototype.slice.call(frame.querySelectorAll('img[data-cap]'));
    let n = slides.length, at = 0;
    const page = readStage(frame);
    let lift = null, liftStage = null;

    const OUT_MS = 200, IN_MS = 300, WAVE_SPAN = 160;
    const EASE_OUT = 'cubic-bezier(0, 0, 0.58, 1)';

    function waveDelays(stage) {
      const mid = stage.host.clientWidth / 2, span = Math.max(1, stage.host.clientWidth);
      let max = 0.0001;
      const ds = stage.cells.map(function (c) {
        const r = c.getBoundingClientRect();
        const d = Math.abs(r.left + r.width / 2 - mid) / span;
        max = Math.max(max, d);
        return d;
      });
      return ds.map(function (d) { return (d / max) * WAVE_SPAN; });
    }

    /* a wave never leaves a fill on cells that stay: the next wave animates
       underneath it and lands back at whatever the old fill says, which is how
       the band once came back from the window with nothing in it */
    function wave(stage, out) {
      if (!stage || !stage.cells.length || REDUCE || !stage.cells[0].animate) {
        return Promise.resolve();
      }
      const ds = waveDelays(stage);
      /* a leaving stage may hold its last frame; a stage that stays must not */
      const keep = out && stage !== page;
      return Promise.all(stage.cells.map(function (c, i) {
        c.getAnimations().forEach(function (a) { a.cancel(); });
        /* each keyframe carries the cell's own sag: a wave written from zero
           flattens the record and drops it back onto the bow in one frame */
        const sag = parseFloat(c.style.getPropertyValue('--pdc-sag-y')) || 0;
        const rest = 'translateY(' + sag + 'px)';
        const off = 'translateY(' + (sag - 20) + 'px)';
        const under = 'translateY(' + (sag + 20) + 'px)';
        return c.animate(out
          ? [{ opacity: 1, transform: rest }, { opacity: 0, transform: off }]
          : [{ opacity: 0, transform: under }, { opacity: 1, transform: rest }],
        { duration: out ? OUT_MS : IN_MS, delay: ds[i], easing: EASE_OUT,
          fill: keep ? 'forwards' : 'backwards' }).finished;
      })).catch(function () {});
    }

    /* ---------- the band's own layout ---------- */
    const ratios = [];
    /* a phone is a phone before it is wide: held sideways it is past 900 and
       still takes the phone's gap */
    function bandGap() {
      return isWide() && !isPhone() ? 44 : 28;
    }

    /* the cap keeps the record's shoulders the same width whatever shape is read:
       uncapped, a landscape collapses its neighbours to nothing */
    const BAND_SHARE = 0.62;

    function layoutBand(stage) {
      if (!stage || !stage.track) return;
      /* the bow is a share of the band's height, written back out so the
         stylesheet keeps the same number for the band's foot and the caption's pull */
      const sag = Math.round(stage.host.clientHeight * SAG_SHARE);
      if (stage.root) stage.root.style.setProperty('--pdc-sag', sag + 'px');
      const h = stage.host.clientHeight - sag, w = stage.host.clientWidth;
      let gap = bandGap(), x = 0;
      stage.lefts = []; stage.widths = [];
      const share = BAND_SHARE * w;
      stage.cells.forEach(function (c, i) {
        const ratio = ratios[i] || 1.5;
        const cw = Math.min(h * ratio, share);
        stage.lefts.push(x); stage.widths.push(cw); x += cw + gap;
        c.style.width = cw + 'px';
        /* cut to the photograph, not the band: a capped landscape in a full-height
           cell leaves the line under the record adrift */
        c.style.height = Math.min(h, cw / ratio) + 'px';
      });
      /* one full turn of the rail, the closing gap included */
      stage.total = x;
      /* under 1.6 bands there is nowhere offscreen for the seam's jump, so a
         short record runs as a rail with ends */
      stage.rail = x >= w * 1.6;
      stage.track.style.gap = gap + 'px';
      stage.railX = restOf(stage, at);
      paint(stage, false);
      /* one listener per stage, holding the ring's invariant after every landing */
      if (stage.settling) return;
      stage.settling = true;
      stage.track.addEventListener('transitionend', function (e) {
        if (e.propertyName !== 'transform' || e.target !== stage.track) return;
        freeTaps(stage);
        stopSweep(stage);
        settle(stage);
      });
    }

    /* ---------- the rail is a ring ----------
       One pair of primitives owns the ring arithmetic; folding at call sites is
       what once sent a step the long way round. The invariant: once a step has
       landed, the offset sits within half a turn of the read photograph's rest;
       settle() restores it and every reader of the offset assumes it. */

    /* how many whole records apart two points on the ring are */
    function turnsApart(stage, d) {
      return stage.rail && stage.total ? Math.round(d / stage.total) : 0;
    }

    /* the shortest signed way across the ring, never longer than half a record */
    function ring(stage, d) {
      return d - turnsApart(stage, d) * stage.total;
    }

    /* where the band stands when photograph i is the one being read */
    function restOf(stage, i) {
      return stage.host.clientWidth / 2 - stage.lefts[i] - stage.widths[i] / 2;
    }

    /* the middle of photograph i as it stands on screen now */
    function faceOf(stage, i) {
      return stage.railX + stage.lefts[i] + stage.widths[i] / 2 +
        turnOf(stage, i) * stage.total;
    }

    /* which turn of the record photograph i stands on: the one that brings it
       nearest the middle */
    function turnOf(stage, i) {
      return turnsApart(stage, stage.host.clientWidth / 2 -
        (stage.railX + stage.lefts[i] + stage.widths[i] / 2));
    }

    /* the layout owns the number and hands it to the stylesheet, so the room,
       the curve and the caption's pull cannot drift apart */
    const SAG_SHARE = 0.15;
    function sagRoom(stage) {
      return parseFloat(getComputedStyle(stage.host).paddingBottom) || 0;
    }

    /* distance from the middle as a share of the band's width; everything that
       answers to distance measures from this one number */
    function awayOf(stage, i, railX) {
      const w = Math.max(1, stage.host.clientWidth);
      return ((railX === undefined ? stage.railX : railX) + stage.lefts[i] +
        turnOf(stage, i) * stage.total + stage.widths[i] / 2 - w / 2) / w;
    }

    /* the held offset is the destination; what must follow the movement itself
       reads the live transform */
    function liveRail(stage) {
      const m = getComputedStyle(stage.track).transform;
      if (m.indexOf('matrix') !== 0) return stage.railX;
      const parts = m.slice(m.indexOf('(') + 1, m.lastIndexOf(')')).split(',');
      const x = parseFloat(parts.length > 6 ? parts[12] : parts[4]);
      return isNaN(x) ? stage.railX : x;
    }

    /* size falls away with distance; the floor keeps the far edge from shrinking
       into a chip */
    const SIZE_FALLOFF = 0.42, SIZE_FLOOR = 0.6;

    /* the bow lifts rather than drops (the only room is above the line), and
       distance is quoted against the shoulder, 0.6 of a band, the furthest a
       visible photograph stands, so the edge neighbour wears the full pose */
    const ARC_SHOULDER = 0.6, ARC_TILT = 8;

    /* the read photograph is always square: it is centred by measurement and
       lands a pixel or two out, and a rail leaning by a degree reads as a
       photograph hung crooked */
    function bow(stage, c, away, read) {
      const a = read ? 0 : Math.min(1, Math.abs(away) / ARC_SHOULDER);
      c.style.setProperty('--pdc-sag-y', (sagRoom(stage) * a * a).toFixed(2) + 'px');
      c.style.setProperty('--pdc-tilt', (ARC_TILT * (away < 0 ? -a : a)).toFixed(3) + 'deg');
    }

    /* redrawn every frame while the band moves: written once per step, the record
       slides between two bows rather than turning through one */
    function sweep(stage) {
      if (!stage || !stage.track || REDUCE || !window.requestAnimationFrame) return;
      /* drawn for the whole travel, not the shorter tap hold: riding the hold left
         the record leaning and straightening in a jump at the end */
      stage.sweeping = true;
      clearTimeout(stage.sweepTimer);
      const ms = parseFloat(getComputedStyle(stage.track).transitionDuration) * 1000;
      stage.sweepTimer = setTimeout(function () { stopSweep(stage); }, (ms || 620) + 60);
      requestAnimationFrame(function frame() {
        if (!stage.sweeping) return;
        const x = liveRail(stage);
        stage.cells.forEach(function (c, i) { bow(stage, c, awayOf(stage, i, x)); });
        requestAnimationFrame(frame);
      });
    }

    /* the landing writes the poses once more from the settled place: the sweep's
       last frame is a pixel or two short of the truth */
    function stopSweep(stage) {
      if (!stage || !stage.sweeping) return;
      clearTimeout(stage.sweepTimer);
      stage.sweeping = false;
      place(stage);
    }

    function place(stage) {
      stage.cells.forEach(function (c, i) {
        const away = awayOf(stage, i);
        c.style.setProperty('--pdc-turn', (turnOf(stage, i) * stage.total) + 'px');
        c.style.setProperty('--pdc-scale',
          Math.max(SIZE_FLOOR, 1 - SIZE_FALLOFF * Math.abs(away)).toFixed(4));
        bow(stage, c, away, i === at);
      });
    }

    function centreBand(stage, i) {
      if (!stage || !stage.lefts || !stage.lefts.length) return;
      stage.railX += ring(stage, restOf(stage, i) - stage.railX);
      paint(stage, true);
    }

    /* hygiene, not correctness: ring() is right at any magnitude, so this runs
       only once the offset is several records out, never inside a step, because
       it costs a forced layout */
    const SETTLE_AFTER = 8;
    function settle(stage) {
      if (!stage || !stage.lefts || !stage.lefts.length || !stage.total) return;
      const rest = restOf(stage, at);
      if (Math.abs(stage.railX - rest) < stage.total * SETTLE_AFTER) return;
      stage.railX = rest;
      paint(stage, false);
    }

    /* offsets rather than a measured box: a photograph mid-travel carries a
       transform, and its box would be read where it is passing through */
    function publishBar(stage) {
      if (!stage || !stage.root || !stage.widths || !stage.widths.length) return;
      stage.root.style.setProperty('--pdc-read', stage.widths[at] + 'px');
      const cell = stage.cells[at];
      if (cell) {
        stage.root.style.setProperty('--pdc-line',
          (stage.host.offsetTop + cell.offsetTop + cell.offsetHeight) + 'px');
      }
    }

    /* a layout carries the band to its place with no travel; a step rides the
       spring the stylesheet holds */
    function paint(stage, animate) {
      if (!stage || !stage.track || !stage.lefts) return;
      if (!animate) stage.track.style.transition = 'none';
      stage.track.style.transform = 'translateX(' + stage.railX + 'px)';
      if (!animate) {
        void stage.track.offsetWidth;
        stage.track.style.transition = '';
      }
      /* a step does not publish the bar here: the turn does, at the moment the
         words cannot be seen, so the line comes back already in its place */
      if (!animate) publishBar(stage);
      place(stage);
    }

    function learnRatios(stage) {
      if (!stage) return;
      stage.imgs.forEach(function (im, i) {
        function take() {
          if (!im.naturalWidth) return;
          const r = im.naturalWidth / im.naturalHeight;
          if (Math.abs((ratios[i] || 0) - r) < 0.001) return;
          ratios[i] = r;
          layoutBand(page); layoutBand(liftStage);
        }
        if (im.complete) take();
        im.addEventListener('load', take);
      });
    }

    learnRatios(page);
    layoutBand(page);
    if (window.ResizeObserver) new ResizeObserver(function () { layoutBand(page); }).observe(frame);
    else window.addEventListener('resize', function () { layoutBand(page); });

    function readStage(host) {
      return {
        host: host,
        /* the bar is the host's sibling */
        root: host.parentElement,
        track: host.querySelector('.pdc-track'),
        cells: Array.prototype.slice.call(host.querySelectorAll('.pdc-cell')),
        imgs: Array.prototype.slice.call(host.querySelectorAll('img[data-cap]'))
      };
    }

    function turnLine(host, stage, cap, count) {
      const bar = host.querySelector('.pdc-bar');
      if (!bar) return;
      const parts = [bar.querySelector('.pdc-cap'), bar.querySelector('.pdc-nav')]
        .filter(Boolean);
      function land() {
        publishBar(stage);
        bar.querySelector('.pdc-cap').textContent = cap;
        bar.querySelector('.pdc-count').textContent = count;
      }
      /* nothing to turn for a line that already says this */
      const same = bar.querySelector('.pdc-cap').textContent === cap &&
        bar.querySelector('.pdc-count').textContent === count;
      if (same || REDUCE || !bar.animate) { land(); return; }
      parts.forEach(function (p) { p.getAnimations().forEach(function (a) { a.cancel(); }); });
      Promise.all(parts.map(function (p) {
        return p.animate([{ opacity: 1, transform: 'translateY(0)' },
          { opacity: 0, transform: 'translateY(-20px)' }],
        { duration: OUT_MS, easing: EASE_OUT, fill: 'forwards' }).finished;
      })).then(function () {
        /* the fill is dropped the moment the new line is drawn: a standing fill
           on a line that stays is what once emptied the band */
        parts.forEach(function (p) { p.getAnimations().forEach(function (a) { a.cancel(); }); });
        land();
        parts.forEach(function (p) {
          p.animate([{ opacity: 0, transform: 'translateY(20px)' },
            { opacity: 1, transform: 'translateY(0)' }],
          { duration: IN_MS, easing: EASE_OUT, fill: 'backwards' });
        });
      }, function () { land(); });
    }

    function label() {
      const cap = slides[at].dataset.cap, count = pad2(at + 1) + ' / ' + pad2(n);
      /* each arrow answers to its own stage: the window's wider band may turn
         where the page's cannot */
      [[root, page], [lift, liftStage]].forEach(function (pair) {
        const host = pair[0], stage = pair[1];
        if (!host || !stage) return;
        turnLine(host, stage, cap, count);
        /* a rail that turns has nothing to stand an arrow down for */
        const prev = host.querySelector('.pdc-prev');
        if (prev) {
          prev.disabled = !turns(stage) && at === 0;
          host.querySelector('.pdc-next').disabled = !turns(stage) && at === n - 1;
        }
      });
    }

    function show(stage, next) {
      if (!stage || !stage.track) return;
      centreBand(stage, next);
      stage.cells.forEach(function (c, i) { c.classList.toggle('on', i === next); });
    }

    function markRel(stage) {
      if (!stage || !stage.track) return;
      const back = stage.rail ? (at - 1 + n) % n : at - 1;
      const on = stage.rail ? (at + 1) % n : at + 1;
      stage.cells.forEach(function (c, i) {
        c.dataset.rel = i === at ? 'on' : i === back ? 'prev' : i === on ? 'next' : 'far';
      });
    }

    /* a record of two turns whatever the rail says: the seam is a photograph
       crossing the band, and with two there is no far end to reach */
    function turns(stage) {
      return stage.rail || n === 2;
    }

    function go(dir) {
      const stage = liftStage || page;
      step(turns(stage) ? (at + dir + n) % n : Math.min(n - 1, Math.max(0, at + dir)));
    }

    /* a photograph decoding inside the travel is the stutter, so neighbours are
       decoded before they are asked for. Decoded pixels belong to the ELEMENT,
       not the address: the window's own copies start cold however warm the
       page's are, so warmth is marked per image. */
    function warm(stage, i) {
      const im = stage && stage.imgs && stage.imgs[(i + n) % n];
      if (!im || im.dataset.warm) return;
      im.dataset.warm = '1';
      im.loading = 'eager';
      if (im.decode) im.decode().catch(function () {});
    }

    /* the neighbours first, the rest once the browser has nothing better to do */
    function warmAround(stage) {
      if (!stage) return;
      warm(stage, at); warm(stage, at - 1); warm(stage, at + 1);
    }

    function warmAll(stage) {
      if (!stage) return;
      const rest = function () { stage.imgs.forEach(function (im, i) { warm(stage, i); }); };
      if (window.requestIdleCallback) requestIdleCallback(rest, { timeout: 1200 });
      else setTimeout(rest, 300);
    }

    /* a tap mid-travel aims at a photograph sliding under a still cursor; drag,
       arrows and trackpad still answer, naming a direction rather than a place */
    const TAP_HOLD_MS = 150;
    function holdTaps(stage) {
      if (!stage || !stage.track) return;
      stage.host.dataset.travelling = '1';
      clearTimeout(stage.tapTimer);
      /* only the moment of the swap is refused, not the whole travel: held for
         the full travel, every second click landed on nothing */
      stage.tapTimer = setTimeout(function () { freeTaps(stage); }, TAP_HOLD_MS);
    }

    function freeTaps(stage) {
      if (!stage) return;
      clearTimeout(stage.tapTimer);
      delete stage.host.dataset.travelling;
    }

    function step(next) {
      const was = at;
      at = next;
      show(page, next);
      show(liftStage, next);
      markRel(page); markRel(liftStage);
      label();
      warmAround(page); warmAround(liftStage);
      if (was === next) return;
      holdTaps(page); holdTaps(liftStage);
      sweep(page); sweep(liftStage);
    }

    function wireArrows(host) {
      host.querySelector('.pdc-prev').addEventListener('click', function () { go(-1); });
      host.querySelector('.pdc-next').addEventListener('click', function () { go(1); });
    }
    wireArrows(root);
    markRel(page);
    label();
    warmAround(page); warmAll(page);

    /* one gesture serves the page's band and the window's; only one is ever
       under a hand */
    const wireWheel = swipeStepper(go);
    if (n > 1) wireWheel(frame);

    /* ---------- dragging the band ----------
       the page keeps every vertical gesture (touch-action: pan-y) */
    let dragged = false;
    function wireBandDrag(stage) {
      if (!stage || !stage.track) return;
      stage.host.addEventListener('pointerdown', function (e) {
        if (n < 2 || e.button || !stage.lefts || !stage.lefts.length) return;
        let startX = e.clientX, moved = false;
        const from = stage.railX;
        /* a hand on the band takes over from whatever travel was under way */
        freeTaps(stage);
        stopSweep(stage);
        stage.track.style.transition = 'none';
        stage.host.classList.add('dragging');

        function move(ev) {
          if (Math.abs(ev.clientX - startX) > DRAG_SLOP) moved = true;
          stage.railX = from + ev.clientX - startX;
          stage.track.style.transform = 'translateX(' + stage.railX + 'px)';
          place(stage);
        }
        function up(ev) {
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', up);
          window.removeEventListener('pointercancel', up);
          stage.track.style.transition = '';
          stage.host.classList.remove('dragging');
          if (!moved) { centreBand(stage, at); return; }
          /* a hand that travelled was steering, so the release is not also a tap */
          dragged = true;
          /* nearest the middle, counted across the turns, so a release past the
             last photograph lands on the first */
          let mid = stage.host.clientWidth / 2, best = at, near = Infinity;
          stage.cells.forEach(function (c, i) {
            const d = Math.abs(faceOf(stage, i) - mid);
            if (d < near) { near = d; best = i; }
          });
          step(best);
        }
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
        window.addEventListener('pointercancel', up);
      });
    }
    wireBandDrag(page);

    frame.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLift(true); }
    });

    /* a neighbour brings itself to the middle, the read one is acted on, and the
       ground answers nothing: mid-travel a second quick click lands on it, and a
       fallback acting there would act on a click meant for a photograph */
    function wireCellTaps(host, stage, onRead) {
      let downX = 0;
      host.addEventListener('pointerdown', function (e) { downX = e.clientX; });
      host.addEventListener('click', function (e) {
        if (dragged) { dragged = false; return; }
        if (host.dataset.travelling) return;
        if (Math.abs(e.clientX - downX) > 10) return;
        const i = stage.cells.indexOf(e.target.closest('.pdc-cell'));
        if (i < 0) return;
        if (i === at) onRead(); else step(i);
      });
    }
    wireCellTaps(frame, page, function () { openLift(); });
    const openMark = root.querySelector('.pdc-open');
    if (openMark) openMark.addEventListener('click', function () { openLift(); });

    function onLiftKey(e) {
      if (e.key === 'Escape') { closeLift(true); return; }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); return; }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); return; }
      /* focus circles close and the arrows, never leaving */
      if (e.key === 'Tab') {
        e.preventDefault();
        const stops = [lift.querySelector('.pdc-close'),
          lift.querySelector('.pdc-prev'), lift.querySelector('.pdc-next')];
        const i = stops.indexOf(document.activeElement);
        stops[(i + (e.shiftKey ? -1 : 1) + stops.length) % stops.length].focus();
      }
    }

    /* byKey decides one thing, on the way out: whether the page is owed its focus back */
    let liftByKey = false;
    function openLift(byKey) {
      if (lift) return;
      liftByKey = !!byKey;
      lift = document.createElement('div');
      lift.className = 'pdc-lift';
      lift.setAttribute('role', 'dialog');
      lift.setAttribute('aria-modal', 'true');
      lift.setAttribute('aria-label', 'photographs, enlarged');
      lift.innerHTML =
        '<button type="button" class="pdc-close" aria-label="close">' +
        '<svg viewBox="0 0 10 10" aria-hidden="true">' +
        '<path d="M1 1 L9 9 M9 1 L1 9" fill="none" stroke="currentColor"/></svg></button>' +
        '<div class="pdc-lift-stage">' +
        pdcTrackHtml(slides.map(function (s) {
          return { src: s.src, cap: s.dataset.cap };
        }), at) +
        '</div>' +
        pdcBarHtml(slides[at].dataset.cap, pad2(at + 1) + ' / ' + pad2(n));
      liftStage = readStage(lift.querySelector('.pdc-lift-stage'));
      markRel(liftStage);
      wireArrows(lift);
      lift.querySelector('.pdc-close').addEventListener('click', function () { closeLift(false); });
      learnRatios(liftStage);
      warmAround(liftStage); warmAll(liftStage);
      wireBandDrag(liftStage);
      /* the window needs its own wheel listener; the page's band alone carrying
         it left a sideways wheel in the window doing nothing */
      if (n > 1) wireWheel(liftStage.host);
      /* given up only by things that are aimed at; a ground that closed on a
         click took the window away mid-step */
      wireCellTaps(liftStage.host, liftStage, function () { closeLift(false); });
      document.addEventListener('keydown', onLiftKey, true);
      document.body.appendChild(lift);
      /* measurable only once it is in the window it will run in */
      layoutBand(liftStage);
      label();
      if (typeof lenis !== 'undefined' && lenis) lenis.stop();
      else document.documentElement.style.overflow = 'hidden';
      lift.querySelector('.pdc-close').focus();
      if (!lift.animate) return;
      lift.animate([{ opacity: 0 }, { opacity: 1 }],
        { duration: OUT_MS, easing: EASE_OUT });
      /* the page's photographs are not waved out: the window's ground is opaque,
         and standing the band down spares the compositor a screenful of blended
         photographs on every step */
      wave(liftStage, false);
      setTimeout(function () { if (lift) frame.dataset.lifted = '1'; }, OUT_MS);
    }

    /* focus goes back only when a keyboard opened or closed the window: a
       hand-reader never asked the page for a place to stand, and giving one
       marks the band for a keyboard nobody is using */
    function closeLift(byKey) {
      if (!lift) return;
      const el = lift, elStage = liftStage;
      lift = null; liftStage = null;
      document.removeEventListener('keydown', onLiftKey, true);
      /* a second window may open while this one is leaving: the one standing owns
         the scroll and the page's band, and a leaving window only takes itself */
      let went = false;
      function gone() {
        if (went) return;
        went = true;
        el.remove();
        if (lift) return;
        if (typeof lenis !== 'undefined' && lenis) lenis.start();
        else document.documentElement.style.overflow = '';
        /* the band takes focus back, but never by moving the page to it */
        if (byKey || liftByKey) frame.focus({ preventScroll: true });
      }
      if (!el.animate) { gone(); return; }
      /* the photographs leave while the ground is already giving way; waiting for
         them made the close read as a black hold */
      wave(elStage, true);
      el.animate([{ opacity: 1 }, { opacity: 0 }],
        { duration: OUT_MS + WAVE_SPAN, easing: EASE_OUT, fill: 'forwards' })
        .finished.then(gone, gone);
      /* the band is given back and its rise begun in the same breath: handed back
         first, it stands in full ink then blanks to start the rise, which is the
         flicker */
      setTimeout(function () {
        if (lift) return;
        delete frame.dataset.lifted;
        wave(page, false);
      }, OUT_MS);
    }
  }
